const fr = {
  translation: {
    // Module Rapports (fleet-api reports/ : catalogue, exécutions, exports, envois programmés)
    reports: {
      windowTitle: "Rapports",
      tabRun: "Générer un rapport",
      tabSchedules: "Envois programmés",
      catalogFailed: "Le catalogue des rapports n'a pas pu être chargé.",
      disabled: "Les rapports sont désactivés pour ce compte. Un administrateur peut les activer dans les Paramètres.",
      scope: "Périmètre",
      scopeCustomer: "Tout le compte",
      scopeFleet: "Une flotte",
      scopeVehicle: "Un véhicule",
      scopeDriver: "Un chauffeur",
      fleet: "Flotte",
      vehicle: "Véhicule",
      driver: "Chauffeur",
      customer: "Client",
      corridor: "Corridor",
      choose: "Choisir…",
      searchFleet: "Rechercher une flotte…",
      searchVehicle: "Rechercher un véhicule ou une plaque…",
      searchDriver: "Rechercher un chauffeur…",
      searchCustomer: "Rechercher un client…",
      searchCorridor: "Rechercher un corridor…",
      noMatch: "Aucun résultat",
      noDrivers: "Aucun chauffeur actif",
      allCustomers: "Tous les clients",
      corridorAny: "Partout (sans corridor)",
      corridorHint: "Seules les positions enregistrées dans ce corridor seront comptées.",
      corridorWidthKm: "± {{width}} km",
      driverHint: "Ne couvre que les périodes où ce chauffeur avait le véhicule.",
      copyReference: "Copier la référence du rapport",
      copyFailed: "La référence n'a pas pu être copiée",
      format: {
        pdf: "Rapport PDF",
        xlsx: "Classeur Excel",
        csv: "Données CSV"
      },
      periodLabel: "Période",
      periods: {
        TODAY: "Aujourd'hui",
        YESTERDAY: "Hier",
        LAST_7_DAYS: "7 derniers jours",
        LAST_30_DAYS: "30 derniers jours",
        THIS_MONTH: "Ce mois-ci",
        LAST_MONTH: "Le mois dernier",
        CUSTOM: "Dates personnalisées"
      },
      from: "Du",
      to: "Au",
      fromTimeHint: "Heure de début (vide : depuis minuit)",
      toTimeHint: "Heure de fin (vide : jusqu'à la fin de la journée)",
      run: "Générer",
      runFailed: "Le rapport n'a pas pu être produit.",
      paramsHint: "Les seuils viennent des paramètres du compte et restent modifiables à chaque exécution.",
      exportReady: "Fichier {{format}} téléchargé.",
      exportFailed: "L'export n'a pas pu être produit.",
      rangeLabel: "Période couverte",
      rowCount: "Lignes",
      vehicleCount: "{{count}} véhicule",
      vehicleCount_plural: "{{count}} véhicules",
      truncated: "La période contient plus de télémétrie qu'une exécution ne peut lire ; resserrez les dates pour une vue complète.",
      noRows: "Rien à signaler sur cette période.",
      chartTitle: "{{count}} véhicules en tête",
      noticesTitle: "Véhicules non mesurables",
      missingSignals: "Nécessite {{signals}}",
      signalWarning: "Aucun boîtier de ce compte ne transmet {{signals}} : ce rapport restera vide jusqu'à l'installation d'un tel équipement.",
      signal: {
        gps: "la position",
        speed: "la vitesse",
        ignition: "le contact moteur",
        odometer: "l'odomètre",
        fuel: "le niveau de carburant",
        temperature: "la température"
      },
      notice: {
        NO_GPS: "son boîtier ne transmet pas la position",
        NO_SPEED: "son boîtier ne transmet pas la vitesse",
        NO_IGNITION: "son boîtier ne transmet pas le contact moteur",
        NO_IGNITION_IN_RANGE: "aucune mesure de contact moteur sur la période",
        NO_DATA_IN_RANGE: "aucune télémétrie sur la période",
        COUNTRY_NOT_RESOLVED: "ses positions ne sont pas encore rattachées à un pays",
        NO_CONSUMPTION_CONFIGURED: "aucune consommation moyenne enregistrée pour ce véhicule",
        UNKNOWN_FUEL_TYPE: "son type de carburant est inconnu, le CO2 ne peut pas être déduit",
        OUTSIDE_CORRIDOR: "il n'a transmis aucune position dans le corridor sélectionné"
      },
      chart: {
        distanceKm: "Distance (km)",
        stoppedMinutes: "Temps à l'arrêt (min)",
        wastedMinutes: "Gaspillage moteur (min)",
        peakKmh: "Vitesse de pointe (km/h)",
        averageKmh: "Vitesse moyenne (km/h)",
        events: "Occurrences",
        minutesOverLimit: "Minutes au-dessus de la limite",
        productiveHours: "Heures productives",
        idleHours: "Heures de gaspillage",
        crossings: "Franchissements",
        co2Kg: "CO2 (kg)",
        daysEmitted: "Jours émis",
        daysSilent: "Jours sans émission"
      },
      summary: {
        trips: "Trajets",
        stops: "Arrêts",
        periods: "Périodes de gaspillage",
        events: "Occurrences",
        crossings: "Franchissements",
        vehicles: "Véhicules",
        countries_visited: "Pays visités",
        total_distance_km: "Distance totale (km)",
        total_duration_minutes: "Durée totale",
        total_stopped_minutes: "Temps à l'arrêt",
        total_wasted_minutes: "Gaspillage moteur",
        wasted_share_percent: "Part des arrêts gaspillée (%)",
        total_minutes_over_limit: "Temps au-dessus de la limite",
        worst_peak_speed_kmh: "Pointe la plus élevée (km/h)",
        fleet_peak_speed_kmh: "Pointe de la flotte (km/h)",
        fleet_average_speed_kmh: "Moyenne de la flotte (km/h)",
        total_gps_distance_km: "Distance GPS totale (km)",
        total_engine_hours: "Heures moteur totales",
        total_idle_hours: "Heures de gaspillage totales",
        total_fuel_litres: "Carburant consommé (L)",
        total_co2_kg: "CO2 (kg)",
        days: "Jours de la période",
        vehicle_days_emitted: "Jours-véhicule émis",
        vehicle_days_silent: "Jours-véhicule sans émission",
        vehicles_silent_whole_period: "Véhicules muets toute la période"
      },
      weekday: {
        "0": "Dimanche",
        "1": "Lundi",
        "2": "Mardi",
        "3": "Mercredi",
        "4": "Jeudi",
        "5": "Vendredi",
        "6": "Samedi"
      },
      schedules: {
        title: "Envois programmés de rapports",
        subtitle: "Choisissez les rapports, les destinataires et l'heure d'envoi. Les fichiers sont joints aux formats retenus.",
        new: "Nouvel envoi",
        newTitle: "Nouvel envoi programmé",
        editTitle: "Modifier l'envoi programmé",
        emptyTitle: "Aucun envoi programmé",
        emptyHint: "Créez-en un pour recevoir les rapports par e-mail sans ouvrir le portail.",
        name: "Nom",
        subject: "Objet de l'e-mail",
        reports: "Rapports à joindre",
        formats: "Joindre en",
        pickFormat: "Choisissez au moins un format de fichier.",
        frequency: "Fréquence",
        daily: "Chaque jour",
        weekly: "Chaque semaine",
        monthly: "Chaque mois",
        weekday: "Jour de la semaine",
        dayOfMonth: "Jour du mois",
        weekdays: "Jours de la semaine",
        daysOfMonth: "Jours du mois",
        daysOfMonthHint: "Jusqu'au 28, pour que l'envoi parte aussi en février.",
        groupedSend: "Envoi groupé",
        groupedSendOn: "un seul e-mail à toutes les adresses ; les destinataires se voient.",
        groupedSendOff: "un e-mail séparé par adresse.",
        sendTime: "Envoi à",
        timezone: "Fuseau horaire (de l'heure d'envoi)",
        mailLanguage: "Langue de l'e-mail",
        recipients: "Destinataires",
        body: "Message",
        bodyPlaceholder: "Texte facultatif ajouté au-dessus de la synthèse.",
        active: "Envoi actif",
        nextRun: "Prochain envoi",
        sendNow: "Envoyer maintenant",
        history: "Historique des envois",
        scheduledFor: "Prévu pour",
        detail: "Détail",
        noRuns: "Cet envoi programmé n'a encore rien expédié.",
        saved: "Envoi programmé enregistré.",
        saveFailed: "L'envoi programmé n'a pas pu être enregistré.",
        deleted: "Envoi programmé supprimé.",
        deleteFailed: "L'envoi programmé n'a pas pu être supprimé.",
        deleteConfirm: "Supprimer l'envoi programmé « {{name}} » ?",
        sent: "Rapport envoyé.",
        sentTo: "Rapport envoyé à {{count}} destinataire.",
        sentTo_plural: "Rapport envoyé à {{count}} destinataires.",
        skippedNoRecipient: "Rien n'a été envoyé : aucune adresse utilisable.",
        sendFailed: "Le rapport n'a pas pu être envoyé.",
        sendFailedCode: "Le rapport n'a pas pu être envoyé ({{code}})."
      }
    },
    // Map warnings panel
    warnings: "Alertes",
    warning_silent: "{{name}} sans signal",
    warning_battery: "{{name}} : batterie à {{level}}%",
    warning_battery_hint: "Batterie du traceur faible",
    last_position: "Dernière position",
    hours_ago: "il y a {{count}} h",
    days_ago: "il y a {{count}} jours",
    trajectory: "Trajectoire",
    // Common
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    close: "Fermer",
    edit: "Modifier",
    create: "Créer",
    update: "Mettre à jour",
    confirm: "Confirmer",
    back: "Retour",
    next: "Suivant",
    search: "Rechercher",
    loading: "Chargement...",
    retry: "Réessayer",
    enabled: "Activée",
    disabled: "Désactivée",
    vcc_loading: "Chargement du centre de contrôle…",
    vcc_title: "Centre de contrôle du véhicule",
    vcc_load_failed: "Impossible de charger le centre de contrôle du véhicule.",
    vcc_geofences: "Géozones",
    vcc_corridors: "Corridors",
    vcc_open_tab: "Ouvrir l'onglet correspondant",
    vcc_enabled_rules: "Règles actives",
    vcc_open_alerts: "Alertes ouvertes",
    vcc_waiting_tracker: "Configuré — en attente d'un traceur. Les zones et règles sont prêtes, mais aucun traceur ne transmet actuellement.",
    vcc_tracking_assignment: "Suivi et affectation",
    vcc_zones_routes: "Zones et itinéraires",
    vcc_zones_hint: "Zones de surveillance directes et héritées effectives pour ce véhicule.",
    vcc_alert_rules: "Règles d'alerte",
    vcc_rules_hint: "Règles directes et héritées effectives pour ce véhicule.",
    vcc_vehicle_alerts: "Alertes du véhicule",
    vcc_alerts_hint: "Consultez et traitez les alertes émises pour ce véhicule.",
    vcc_attach_geofence: "Associer une géozone",
    vcc_attach_corridor: "Associer un corridor",
    vcc_create_geofence: "Créer une géozone",
    vcc_create_corridor: "Créer un corridor",
    vcc_attach_existing: "Associer un élément existant : {{type}}",
    vcc_attach: "Associer",
    vcc_create_rules: "Créer des règles de surveillance",
    vcc_triggers: "Déclencheurs",
    vcc_rules: "Règles",
    vcc_manage_source: "Gérez cette association depuis sa flotte, sa mission ou son traceur source.",
    vcc_manage_zone: "Ouvrir et gérer la zone",
    vcc_detach: "Dissocier du véhicule",
    vcc_detach_confirm: "Dissocier « {{name}} » de ce véhicule ? La géométrie de la zone ne sera pas supprimée.",
    vcc_no_zones: "Aucune zone ni aucun itinéraire ne s'applique à ce véhicule",
    vcc_no_zones_hint: "Associez une zone existante ou créez-en une depuis la carte de flotte.",
    vcc_no_available_zones: "Aucune zone disponible",
    vcc_zone_options_failed: "Impossible de charger les zones disponibles",
    vcc_zone_attached: "Zone associée au véhicule",
    vcc_zone_attach_failed: "Échec de l'association de la zone",
    vcc_zone_detached: "Zone dissociée du véhicule",
    vcc_zone_detach_failed: "Échec de la dissociation de la zone",
    vcc_create_rule: "Créer une règle",
    vcc_create_first_rule: "Créer la première règle",
    vcc_no_rules: "Aucune règle d'alerte ne s'applique à ce véhicule",
    vcc_rule_updated: "Règle d'alerte mise à jour",
    vcc_rule_update_failed: "Échec de la mise à jour de la règle",
    vcc_manage_rule_source: "Les règles héritées doivent être gérées depuis leur source",
    vcc_inherited_rule_hint: "Gérer à la source",
    vcc_trigger: "Déclencheur",
    vcc_zone: "Zone",
    vcc_channels: "Canaux",
    vcc_recipients: "Destinataires",
    vcc_schedule: "Planification",
    vcc_always: "Toujours",
    vcc_position_required: "Ce véhicule n'a aucune position enregistrée. Affectez un traceur actif avant de créer une zone depuis sa position.",
    vcc_active_missions: "Missions actives",
    vcc_open_mission: "Ouvrir la gestion de la mission",
    vcc_no_active_alerts: "Aucune alerte active pour ce véhicule",
    vcc_no_alert_history: "Aucun historique d'alertes résolues",
    vcc_acknowledge: "Acquitter",
    vcc_resolve: "Résoudre",
    vcc_alert_acknowledged: "Alerte acquittée",
    vcc_alert_resolved: "Alerte résolue",
    vcc_alert_action_failed: "Échec de l'action sur l'alerte",
    id: "ID",
    speed: "Vitesse",
    show_route: "Afficher le trajet",
    register_position: "Enregistrer la position",
    create_geofence_here: "Créer une géofence ici",
    start_route_here: "Démarrer un itinéraire ici",
    trajectory_markers: "Symboles",
    journey_start: "Début du trajet",
    journey_end: "Arrivée / fin de période",
    device_event: "Événement véhicule",
    device_alert: "Alerte véhicule",
    stop: "Arrêt",
    parking: "Stationnement",
    parking_5h: "Stationnement (5 h+)",
    current_position: "Position actuelle",
    more_events: "autres événements",
    events_at_this_position: "événements à cette position",
    toggle_device_events_hint: "Afficher ou masquer les événements du véhicule sur le trajet",
    toggle_device_alerts_hint: "Afficher ou masquer les alertes véhicule et les règles déclenchées sur le trajet",
    toggle_stops_hint: "Afficher ou masquer les arrêts sur le trajet",
    toggle_parking_hint: "Afficher ou masquer les stationnements longs sur le trajet",
    map: "Carte",
    stops: "Arrêts",
    stats: "Stats",
    stop_analysis: "Analyse des arrêts",
    interactive_timeline: "Timeline interactive",
    restart_replay: "Recommencer la lecture",
    previous_point: "Point précédent",
    play_replay: "Lire le trajet",
    pause_replay: "Mettre en pause",
    next_point: "Point suivant",
    trajectory_timeline: "Timeline du trajet",
    replay_speed: "Vitesse de lecture",
    no_data: "Aucune donnée",
    detailed_statistics: "Statistiques détaillées",
    distance: "Distance",
    trip_duration: "Durée du trajet",
    average_speed: "Vitesse moyenne",
    maximum_speed: "Vitesse maximale",
    speed_p95: "Vitesse au 95e percentile",
    moving_time: "Temps en mouvement",
    stopped_time: "Temps à l’arrêt",
    detected_stops: "Arrêts détectés",
    gps_points: "Points GPS",
    itinerary: "Itinéraire",
    history: "Historique",
    live_route_refresh_hint: "Le trajet en direct s’actualise automatiquement",
    error: "Erreur",
    success: "Succès",
    warning: "Attention",
    active: "Actif",
    inactive: "Inactif",
    yes: "Oui",
    no: "Non",
    none: "Aucun",
    unknown: "Inconnu",
    all: "Tout",
    select: "Sélectionner",
    remove: "Retirer",
    add: "Ajouter",
    done: "Terminé",
    reset: "Réinitialiser",
    apply: "Appliquer",
    total: "Total",
    filtered: "Filtré",
    actions: "Actions",
    details: "Détails",
    description: "Description",
    name: "Nom",
    type: "Type",
    status: "État",
    priority: "Priorité",
    notes: "Notes",
    required: "Requis",
    optional: "Optionnel",
    not_provided: "Non renseigné",
    none_assigned: "Aucun assigné",
    no_results: "Aucun résultat trouvé",
    select_all: "Tout sélectionner",
    clear_all: "Tout effacer",
    confirmation: "Confirmation",
    action_cannot_undone: "Cette action est irréversible.",
    minimize: "Réduire",
    maximize: "Agrandir",

    // Units
    kmh: "km/h",
    degrees: "°",
    percent: "%",
    celsius: "°C",
    km: "km",
    m: "m",
    hours: "h",
    minutes: "min",
    years: "ans",
    points: "pts",
    devices: "appareil(s)",

    // Header
    fleet_portal: "SiniFleet",
    professional_fleet_management: "Gestion Professionnelle de Flotte",
    search_placeholder: "Rechercher véhicule, conducteur...",
    live: "En direct",
    paused: "En pause",
    last_update: "Dernière mise à jour",
    vehicles: "Véhicules",
    in_movement: "En mouvement",
    stopped_count: "Arrêtés",
    no_connection: "Hors ligne",

    // Login
    login_title: "SiniFleet",
    login_subtitle: "Système de Gestion Professionnelle de Flotte",
    login_window_title: "Connexion SiniFleet",
    username: "Nom d'utilisateur",
    password: "Mot de passe",
    username_placeholder: "Entrez votre nom d'utilisateur",
    password_placeholder: "Entrez votre mot de passe",
    sign_in: "Se connecter",
    signing_in: "Connexion en cours...",
    remember_me: "Se souvenir de moi",
    forgot_password: "Mot de passe oublié ?",
    login_error: "Une erreur inattendue s'est produite",
    login_failed: "Échec de la connexion",
    login_copyright: "© 2025 SiniFleet - Gestion Professionnelle de Flotte",
    welcome_back: "Bon retour",
    login_description: "Connectez-vous pour accéder à votre tableau de bord",
    secure_access: "Accès sécurisé",
    secure_access_desc: "Protection multifacteur pour chaque compte",
    fleet_operations: "Opérations de flotte",
    fleet_operations_desc: "Suivi, missions, alertes et administration",
    mfa_setup_title: "Configurez votre application d’authentification",
    mfa_setup_description: "Scannez le QR code dans votre application, puis saisissez le code de vérification.",
    mfa_qr_alt: "QR code de configuration de l’authentificateur",
    mfa_manual_secret: "Clé de configuration manuelle",
    mfa_authenticator_code: "Code d’authentification",
    mfa_confirm_setup: "Confirmer la configuration à deux facteurs",
    mfa_choose_title: "Choisissez votre méthode à deux facteurs",
    mfa_choose_description: "Sélectionnez comment recevoir vos codes de vérification lors de la connexion.",
    mfa_choose_totp_description: "Utilisez Microsoft Authenticator, Google Authenticator ou une application compatible.",
    mfa_choose_email_description: "Recevez un code à usage unique sur votre adresse e-mail vérifiée.",
    mfa_verify_title: "Vérifiez votre identité",
    mfa_verify_description: "Utilisez votre authentificateur, un code reçu par e-mail ou un code de récupération.",
    mfa_method_totp: "Authentificateur",
    mfa_method_email: "E-mail",
    mfa_method_recovery: "Récupération",
    mfa_email_sent: "Un code de vérification a été envoyé à votre adresse e-mail.",
    mfa_email_send_failed: "Le code par e-mail n’a pas pu être envoyé.",
    mfa_email_resend: "Renvoyer le code",
    mfa_recovery_code: "Code de récupération",
    mfa_verification_code: "Code de vérification",
    mfa_verify_action: "Vérifier et se connecter",
    mfa_back_to_login: "Retour à la connexion",
    mfa_recovery_title: "Enregistrez vos codes de récupération",
    mfa_recovery_description: "Ces codes à usage unique ne sont affichés que maintenant. Conservez-les en lieu sûr.",
    mfa_recovery_acknowledge: "J’ai enregistré ces codes de récupération dans un endroit sûr.",
    mfa_recovery_missing: "Les codes de récupération n’ont pas été retournés. Contactez un administrateur.",
    copy_codes: "Copier les codes",
    copied: "Copié",
    continue: "Continuer",
    invite_title: "Acceptez votre invitation",
    invite_description: "Créez un mot de passe robuste, puis sécurisez votre compte avec un authentificateur.",
    invite_password_length: "Le mot de passe doit contenir au moins 12 caractères.",
    invite_password_policy: "Utilisez au moins 12 caractères avec majuscule, minuscule, chiffre et symbole.",
    invite_password_hint: "Utilisez au moins 12 caractères avec majuscule, minuscule, chiffre et symbole, sans réutiliser un autre mot de passe.",
    invite_accept: "Accepter l’invitation",
    invite_enrollment_required: "La configuration d’un authentificateur est obligatoire pour activer cette invitation.",
    new_password: "Nouveau mot de passe",
    confirm_password: "Confirmer le mot de passe",
    passwords_do_not_match: "Les mots de passe ne correspondent pas.",
    required_capability: "Capacité requise",
    workspace_switcher: "Espace client actif",
    workspace_platform: "Plateforme",
    workspace_switch_failed: "Impossible de changer d’espace",
    invite_user: "Inviter un utilisateur",
    invite_only_hint: "L’utilisateur choisit son mot de passe depuis une invitation sécurisée par e-mail.",
    send_invitation: "Envoyer l’invitation",
    invitation_sent: "Invitation envoyée",
    invitation_email_failed: "L’utilisateur a été créé, mais l’e-mail d’invitation n’a pas pu être envoyé. Configurez le serveur e-mail Fleet puis renvoyez l’invitation.",
    customer_workspaces: "Espaces clients",
    platform_access: "Accès aux plateformes",
    platform_required_hint: "Fleet Portal reste activé pour l’intégration sécurisée et la gestion du compte.",
    custom_capabilities: "Capacités personnalisées",
    reset_role_defaults: "Rétablir les valeurs du rôle",
    workspace_required: "Sélectionnez au moins un espace client.",
    no_workspaces: "Aucun espace client n’est disponible.",
    user_required_fields: "Le nom d’utilisateur, le nom complet et un e-mail valide sont requis.",
    capabilities_load_failed: "Impossible de charger les capacités.",
    users_load_failed: "Impossible de charger les utilisateurs.",
    user_save_failed: "Impossible d’enregistrer l’utilisateur.",
    deactivate_user_confirm: "Désactiver {{username}} ?",

    // Auth / Protected Route
    checking_auth: "Vérification de l'authentification...",
    access_denied: "Accès Refusé",
    access_denied_message: "Vous n'avez pas la permission d'accéder à cette page.",
    required_role: "Rôle requis",
    your_role: "Votre rôle",
    go_back: "Retour",
    logout: "Déconnexion",

    // Vehicle Status
    // Bleu en roulage, vert à l'arrêt, rouge dès la perte du signal,
    // gris quand aucun boîtier n'est monté.
    tracking_moving: "En roulage",
    tracking_parked: "Stationné",
    tracking_no_signal: "Plus de signal",
    tracking_offline: "Hors ligne",
    tracking_not_tracked: "Non suivi",
    map_controls: {
      follow_on: "Suivre le véhicule dans ses déplacements",
      follow_off: "Ne plus suivre le véhicule",
      solo_on: "N'afficher que ce véhicule",
      solo_off: "Réafficher toute la flotte",
      cluster_title: "{{count}} événements ici. Cliquer pour zoomer."
    },
    warnings_show: "Afficher les alertes",
    vehicle_pucks: "Pastilles véhicule",
    moving: "En mouvement",
    stopped: "Arrêté",
    idle: "Inactif",
    offline: "Hors ligne",
    maintenance: "Maintenance",
    en_route: "En route",
    out_of_service: "Hors service",

    // Vehicle List
    vehicle_list: "Liste des véhicules",
    no_vehicles: "Aucun véhicule disponible",
    search_vehicles: "Rechercher des véhicules...",
    no_vehicles_found: "Aucun véhicule trouvé",
    try_adjusting_search: "Essayez d'ajuster votre recherche",
    selected_vehicle: "Véhicule sélectionné",
    booking: "Réservation",
    battery: "Batterie",
    signal: "Signal",

    // Driver assignment (Driver tab of the vehicle window)
    current_driver: "Chauffeur actuel",
    assign_driver: "Affecter un chauffeur",
    choose_driver: "Choisir un chauffeur",
    search_driver: "Rechercher un chauffeur…",
    release_driver: "Libérer le chauffeur",
    no_current_driver: "Aucun chauffeur n'est affecté à ce véhicule.",
    no_drivers_hint: "Aucun chauffeur actif pour l'instant. Ajoutez-en un dans la Gestion du personnel.",
    driver_handover_hint: "Affecter un autre chauffeur met fin à l'affectation en cours au même instant.",
    driver_history: "Historique des chauffeurs",
    no_driver_history: "Aucun chauffeur n'a jamais été affecté à ce véhicule.",
    driver_assigned: "Chauffeur affecté",
    driver_assign_failed: "L'affectation du chauffeur a échoué",
    driver_released: "Chauffeur libéré",
    driver_release_failed: "La libération du chauffeur a échoué",
    since: "Depuis",
    no_match: "Aucun résultat",

    // Vehicle Info
    select_vehicle: "Sélectionnez un véhicule",
    to_see_info: "pour voir ses informations",
    current_status: "État actuel",
    driver: "Conducteur",
    location: "Localisation",
    address_not_available: "Adresse non disponible",
    metrics: "Métriques",
    heading: "Cap",
    device_status: "État du dispositif",
    fuel: "Carburant",
    temperature: "Température",
    additional_info: "Informations supplémentaires",
    odometer: "Odomètre",
    engine_hours: "Heures moteur",
    view_full_history: "Voir l'historique complet",
    generate_report: "Générer un rapport",

    // Timeline
    timeline: "Chronologie",
    select_vehicle_timeline: "Sélectionnez un véhicule pour voir sa chronologie",
    last_hour: "Dernière heure",
    last_6_hours: "6 dernières heures",
    last_12_hours: "12 dernières heures",
    last_24_hours: "24 dernières heures",
    last_3_days: "3 derniers jours",
    no_timeline_data: "Aucune donnée de chronologie disponible",
    current_speed: "Vitesse actuelle",

    // Map
    vehicle_status_legend: "État des véhicules",
    fleet_map: "Carte de la Flotte",

    // Dashboard
    dashboard_title: "SiniFleet",
    window_layout_management: "Gestion de la disposition des fenêtres",
    window_layouts: "Dispositions de fenêtres",
    office_layout: "Bureau",
    office_layout_desc: "Carte + Véhicules + Vitesse + Événements + Corridors",
    focus_mode: "Focus",
    focus_mode_desc: "Carte + Corridors uniquement",
    monitoring: "Surveillance",
    monitoring_desc: "Carte + Vitesse + Analyse d'événements",
    minimal: "Minimal",
    minimal_desc: "Carte seule, espace de travail épuré",
    mission_ops: "Opérations de mission",
    mission_ops_desc: "Carte + Missions + Personnel + Véhicules",
    fleet_admin: "Administration de flotte",
    fleet_admin_desc: "Utilisateurs + Véhicules + Gestion des alertes",
    full_operations: "Opérations complètes",
    full_operations_desc: "Toutes les fenêtres ouvertes pour une vue d'ensemble",
    panels_active: "panneaux actifs",
    custom_layouts: "Dispositions personnalisées",
    save_current_layout: "Enregistrer la disposition actuelle",
    save_layout: "Enregistrer la disposition",
    reset_to_default: "Réinitialiser par défaut",
    enter_layout_name: "Entrez le nom de la disposition (ex: Mon Espace)",
    delete_layout: "Supprimer la disposition",
    layout_saved: "Disposition enregistrée avec succès",
    layout_deleted: "Disposition supprimée",
    layout_reset: "Réinitialisé à la disposition par défaut",
    switch_light_mode: "Passer en mode clair",
    switch_dark_mode: "Passer en mode sombre",
    layout_mode: "Mode fenêtre",
    layout_floating: "Flottant",
    layout_fixed: "Grille fixe",
    layout_dashboard: "Tableau de bord",
    preset_layouts: "Dispositions prédéfinies",
    layout_applied: "Disposition \"{{name}}\" appliquée",
    workspace_mode: "Mode d’espace de travail",
    workspace_fixed: "Espace de travail fixe",
    workspace_fixed_desc: "Utilisez un module à la fois avec une navigation persistante.",
    workspace_mac: "Fenêtres Mac",
    workspace_mac_desc: "Ouvrez, déplacez, redimensionnez et réduisez plusieurs fenêtres.",
    workspace_navigation: "Modules de l’espace de travail",
    workspace_group_tracking: "Suivi",
    workspace_group_operations: "Opérations",
    workspace_group_administration: "Administration",
    workspace_group_management: "Gestion",

    // Affectation de transport (itinéraire / départ-destination)
    transport_assign_title: "Affecter un transport",
    transport_mode_itinerary: "Itinéraire",
    transport_mode_places: "Départ / destination",
    transport_itinerary: "Itinéraire (trajectoire)",
    transport_select_itinerary: "Sélectionner une trajectoire…",
    transport_no_itineraries: "Aucune trajectoire définie — créez-en une dans Trajectoires.",
    transport_itinerary_hint: "Le départ et la destination proviennent des extrémités de la trajectoire ; la progression suit l'itinéraire.",
    transport_departure: "Départ",
    transport_destination: "Destination",
    transport_select_place: "Sélectionner un lieu…",
    transport_no_itinerary_option: "Aucun itinéraire — choisissez départ et destination ci-dessous",
    base_location: "Localisation de base (note manuelle)",
    base_location_hint: "Note libre (dépôt, parc…). La position GPS en direct vient de la balise ; le départ est le point de départ du transport.",
    transport_no_places: "Aucun lieu — les lieux proviennent des extrémités de trajectoires et des géofences.",
    transport_pick_places: "Choisissez un départ et une destination",
    transport_save: "Affecter",
    transport_clear: "Retirer le transport",
    transport_save_failed: "Échec de l'enregistrement du transport",
    transport_progress: "Progression du trajet",
    workspace_collapse_panel: "Réduire le panneau véhicules",
    workspace_expand_panel: "Développer le panneau véhicules",
    workspace_show_vehicles: "Véhicules",
    workspace_dock_collapse: "Réduire les analyses",
    workspace_dock_expand: "Développer les analyses",
    workspace_drawer_resize: "Glisser pour redimensionner",
    period_label: "Période",
    data_points: "Points de données",
    avg_short: "moy.",
    speed_select_hint: "pour voir son graphique de vitesse",
    speed_no_data: "Aucune donnée de vitesse",
    speed_actual: "Vitesse réelle",
    for_selected_period: "pour la période sélectionnée",
    events_select_hint: "Sélectionnez un véhicule pour voir les arrêts et les événements balise",
    stop_events_title: "Arrêts > 10 min",
    balise_events_title: "Événements balise",
    no_stop_events: "Aucun arrêt de plus de 10 minutes trouvé",
    no_balise_events: "Aucun événement balise pour la période sélectionnée",
    recent_events: "Événements récents :",
    long_stops: "Arrêts longs",
    total_stop_time: "Temps d'arrêt total",
    detailed_stops: "Détail des arrêts",
    access_lock_events: "Événements accès/verrou",
    duration_min: "Durée (min)",
    stop_duration: "Durée d'arrêt",

    // Dashboard Windows
    speed_analysis: "Analyse de vitesse",
    event_analysis: "Analyse des événements",
    corridor_management: "Gestion des corridors",
    corridor_mgmt_desc: "Carte + Vehicules + Corridors",
    user_management_title: "Gestion des utilisateurs",
    alert_rules_system: "Système d'alertes et règles",
    fleet_assignment_config: "Affectation & Alertes",
    fleet_assignment_config_desc: "Configurer les alertes, géofences et corridors pour les conteneurs et actifs",
    fleet_staff_management: "Gestion du personnel",
    fleet_vehicle_operations: "Opérations véhicules",
    mission_control_system: "Système de contrôle des missions",
    fleet_vehicles: "Véhicules de la flotte",
    corridors_geofences: "Corridors et Géozones",
    user_role_management: "Gestion des utilisateurs et rôles",
    events_analysis: "Analyse des événements",

    // Taskbar
    auto_hide_on: "Masquage auto ACTIVÉ - La barre se masquera automatiquement",
    auto_hide_off: "Masquage auto DÉSACTIVÉ - La barre reste visible",
    disable_corridor_tracking: "Désactiver le suivi de corridor",
    enable_corridor_tracking: "Activer le suivi de corridor",
    hide_corridor: "Masquer le corridor",
    show_corridor: "Afficher le corridor",
    tracking_active: "Suivi actif",
    center_on_corridors: "Centrer sur les corridors",
    more_corridors: "+{{count}} corridors supplémentaires",
    na: "N/D",

    // Mission Dashboard
    mission_dashboard: "Tableau de bord des missions",
    new_mission: "Nouvelle Mission",
    search_missions: "Rechercher des missions...",
    active_missions: "Actives",
    completed_missions: "Terminées",
    delayed_missions: "En retard",
    edit_mission: "Modifier la mission",
    delete_mission: "Supprimer la mission",
    unassigned: "Non assigné",
    manage_tasks: "Gérer les tâches",
    start: "Démarrer",
    mission_progress: "Progression de la mission",
    mission_details: "Détails de la mission",
    planned_start: "Début prévu",
    planned_end: "Fin prévue",
    actual_start: "Début réel",
    select_mission: "Sélectionner une Mission",
    select_mission_desc: "Choisissez une mission dans la liste pour voir les détails et la progression",
    loading_missions: "Chargement du contrôle de mission...",
    mission_created: "Mission \"{{name}}\" créée avec succès",
    mission_updated: "Mission \"{{name}}\" mise à jour avec succès",
    mission_deleted: "Mission \"{{name}}\" supprimée avec succès !",
    delete_mission_confirm: "Êtes-vous sûr de vouloir supprimer la mission \"{{name}}\" ?",
    delete_mission_warning: "Cela supprimera définitivement :",
    delete_mission_items: "Détails et progression de la mission, Toutes les tâches associées, Historique et journaux de la mission",
    no_missions: "Aucune mission trouvée",
    failed_load_missions: "Échec du chargement des missions depuis le serveur",
    failed_delete_mission: "Échec de la suppression de la mission",
    alert_sequence_progress: "Progression de la séquence d'alertes",
    departure: "Départ",
    arrival: "Arrivée",
    return_trip: "Retour",
    loading_status: "Chargement",
    in_progress: "En cours",
    planned: "Planifié",
    customer: "Client",

    // Mission Creator
    create_new_mission: "Créer une nouvelle mission",
    edit_mission_title: "Modifier la mission",
    mission_setup_progress: "Progression de la configuration",
    mission_editing: "Modification de la mission",
    update_mission_details: "Mettre à jour les détails de la mission",
    step_of: "Étape {{current}} de {{total}}",
    mission_information: "Informations sur la mission",
    mission_name: "Nom de la mission",
    mission_name_placeholder: "ex: Livraison au Port de Bamako",
    mission_type: "Type de mission",
    mission_description: "Détails de la mission...",
    staff_assignment: "Attribution du personnel",
    assign_staff: "Assigner des membres du personnel",
    primary_staff: "Personnel responsable principal",
    select_primary_staff: "Sélectionner le personnel principal...",
    additional_staff: "Personnel supplémentaire (Optionnel)",
    primary_label: "PRINCIPAL",
    total_staff_assigned: "Personnel total assigné",
    loading_staff: "Chargement du personnel disponible...",
    no_staff_available: "Aucun personnel disponible pour ce type de mission",
    vehicle_assignment: "Attribution des véhicules",
    filter_by_customer: "Filtrer par client",
    filter_by_type: "Filtrer par type",
    all_customers: "Tous les clients",
    all_types: "Tous les types",
    search_vehicles_ellipsis: "Rechercher des véhicules...",
    select_vehicles: "Sélectionner des véhicules (Optionnel)",
    vehicles_match: "{{count}} véhicules correspondent aux filtres",
    asset: "Actif",
    plate: "Plaque",
    owner: "Propriétaire",
    container: "Conteneur",
    vehicles_selected: "{{count}} véhicules sélectionnés",
    loading_vehicles: "Chargement des véhicules disponibles...",
    no_vehicles_available: "Aucun véhicule disponible",
    alert_route_config: "Configuration des alertes et itinéraires",
    create_alert: "Créer une alerte",
    select_mission_alerts: "Sélectionner les alertes de mission (Optionnel)",
    select_alerts_desc: "Choisissez les alertes qui surveilleront cette mission",
    manual_route: "Informations d'itinéraire manuel (Optionnel)",
    origin_address: "Adresse d'origine...",
    destination_address: "Adresse de destination...",
    schedule: "Planification",
    planned_start_time: "Heure de début prévue",
    planned_end_time: "Heure de fin prévue",
    customer_information: "Informations client",
    select_customer: "Sélectionner un client",
    customer_name_manual: "Nom du client (Saisie manuelle)",
    creating: "Création en cours...",
    updating: "Mise à jour en cours...",
    create_mission: "Créer la mission",
    update_mission: "Mettre à jour la mission",
    please_fill_mission: "Veuillez remplir le nom de la mission et assigner le personnel principal",
    failed_load_staff: "Échec du chargement des données du personnel",
    failed_load_vehicles: "Échec du chargement des données des véhicules",
    failed_load_form: "Échec du chargement des données du formulaire",
    failed_create_mission: "Échec de la création de la mission",
    please_login: "Veuillez vous connecter d'abord pour créer des missions",

    // Mission types
    transport_operations: "Opérations de transport",
    logistics_operations: "Opérations logistiques",
    maintenance_operations: "Opérations de maintenance",
    security_operations: "Opérations de sécurité",
    provider_operations: "Opérations prestataires",
    administrative_operations: "Opérations administratives",
    delivery: "Livraison",
    pickup: "Enlèvement",
    round_trip: "Aller-retour",
    priority_low: "Faible",
    priority_medium: "Moyenne",
    priority_high: "Haute",
    priority_urgent: "Urgente",

    // User Management
    user_management: "Gestion des utilisateurs",
    manage_users_desc: "Gérer les utilisateurs du système et les permissions",
    add_user: "Ajouter un utilisateur",
    search_users: "Rechercher par nom, email, identifiant, département...",
    role: "Rôle",
    all_roles: "Tous les rôles",
    administrator: "Administrateur",
    operator: "Opérateur",
    viewer: "Lecteur",
    fleet_manager: "Gestionnaire de flotte",
    all_users: "Tous les utilisateurs",
    active_only: "Actifs uniquement",
    inactive_only: "Inactifs uniquement",
    users_count: "{{shown}} sur {{total}} utilisateurs",
    admins: "Admins",
    operators: "Opérateurs",
    viewers: "Lecteurs",
    loading_users: "Chargement des utilisateurs...",
    no_users_found: "Aucun utilisateur trouvé",
    try_adjusting_filters: "Essayez d'ajuster votre recherche ou vos filtres",
    last_login: "Dernière connexion",
    edit_user: "Modifier l'utilisateur",
    delete_user: "Supprimer l'utilisateur",
    create_new_user: "Créer un nouvel utilisateur",
    full_name: "Nom complet",
    email: "Email",
    phone: "Téléphone",
    department: "Département",
    active_user: "Utilisateur actif",
    permissions: "Permissions",
    user_notes: "Notes supplémentaires sur cet utilisateur...",
    user_created: "Utilisateur \"{{name}}\" créé avec succès",
    user_updated: "Utilisateur \"{{name}}\" mis à jour avec succès",
    user_deactivated: "Utilisateur \"{{name}}\" désactivé avec succès",
    delete_user_confirm: "Supprimer l'utilisateur \"{{name}}\" ? Cette action est irréversible.",
    failed_load_users: "Échec du chargement des utilisateurs",
    failed_create_user: "Échec de la création de l'utilisateur",
    failed_update_user: "Échec de la mise à jour de l'utilisateur",
    failed_delete_user: "Échec de la suppression de l'utilisateur",

    // Role descriptions
    viewer_desc: "Accès en lecture seule",
    operator_desc: "Opérations quotidiennes",
    fleet_manager_desc: "Opérations complètes",
    admin_desc: "Accès système complet",
    customer_role_desc: "Ses propres véhicules uniquement",

    // Staff Management
    staff_management: "Gestion du Personnel",
    staff_management_desc: "Gérer les conducteurs, superviseurs et personnel opérationnel",
    drivers: "Conducteurs",
    supervisors: "Superviseurs",
    prestateurs: "Prestataires",
    add_staff: "Ajouter un membre du personnel",
    staff_directory: "Répertoire du personnel",
    availability: "Disponibilité",
    performance: "Performance",
    certifications: "Certifications",
    search_staff: "Rechercher du personnel...",
    all_staff_types: "Tous les types",
    staff_drivers: "Conducteurs",
    staff_supervisors: "Superviseurs",
    staff_loaders: "Chargeurs",
    staff_coordinators: "Coordinateurs",
    staff_maintenance: "Maintenance",
    staff_security: "Sécurité",
    staff_external: "Prestataires externes",
    all_status: "Tous les statuts",
    on_leave: "En congé",
    staff_code: "Code personnel",
    license: "Permis",
    missions_count: "Missions",
    company: "Entreprise",
    external: "Externe",
    internal: "Interne",
    personal_info: "Informations personnelles",
    hire_date: "Date d'embauche",
    professional_info: "Informations professionnelles",
    shift_pattern: "Modèle de poste",
    supervisor: "Superviseur",
    driver_info: "Informations conducteur",
    license_number: "Numéro de permis",
    license_class: "Classe de permis",
    license_expiry: "Expiration du permis",
    expiring_soon: "Expire bientôt",
    missions_completed: "Missions accomplies",
    employment_summary: "Résumé d'emploi",
    employment_type: "Type d'emploi",
    external_provider: "Prestataire externe",
    internal_staff: "Personnel interne",
    provider_company: "Entreprise prestataire",
    provider_type: "Type de prestataire",
    freight_forwarder: "Transitaire",
    customs_broker: "Courtier en douane",
    contract_carrier: "Transporteur contractuel",
    seniority: "Ancienneté",
    performance_metrics: "Métriques de performance",
    performance_desc: "Les analyses de performance détaillées seront implémentées ici.",
    certifications_desc: "La gestion des certifications sera implémentée ici.",
    select_staff: "Sélectionner un membre du personnel",
    select_staff_desc: "Choisissez un membre du personnel dans la liste pour voir les détails",
    remove_staff_confirm: "Êtes-vous sûr de vouloir retirer {{name}} du système ?",
    staff_removed: "Membre du personnel {{name}} retiré avec succès",

    // Alert Management
    alert_management: "Gestion des alertes de flotte",
    alert_management_desc: "Créer, gérer et configurer les alertes de la flotte",
    alert_guide: "Guide des alertes",
    manage_alerts: "Gérer les alertes",
    new_alert: "Nouvelle alerte",
    alerts_count: "{{count}} Alertes",
    vehicles_count: "{{count}} Véhicules",
    zones_count: "{{count}} Zones",
    routes_count: "{{count}} Itinéraires",
    alert_updated: "Alerte \"{{name}}\" mise à jour avec succès !",
    alert_created: "Alerte \"{{name}}\" créée avec succès !",
    alert_activated: "Alerte \"{{name}}\" activée",
    alert_deactivated: "Alerte \"{{name}}\" désactivée",
    alert_deleted: "Alerte \"{{name}}\" supprimée avec succès",
    delete_alert_confirm: "Êtes-vous sûr de vouloir supprimer l'alerte \"{{name}}\" ?",
    failed_load_geofences: "Échec du chargement des géozones pour les alertes",
    failed_load_corridors: "Échec du chargement des corridors pour les alertes",

    // Alert Creation
    alert_creation_wizard: "Assistant de création d'alerte",
    step_n_of_m: "Étape {{n}} de {{m}}",
    percent_complete: "% Terminé",
    alert_name: "Nom de l'alerte",
    alert_name_desc: "Entrez un nom descriptif pour votre alerte",
    alert_name_placeholder: "ex: Alerte d'entrée entrepôt, Avertissement de vitesse...",
    alert_type_config: "Type et configuration de l'alerte",
    alert_type_config_desc: "Choisissez le type d'alerte et configurez ses paramètres",
    alert_type: "Type d'alerte",
    choose_alert_type: "Choisir le type d'alerte...",
    alert_config: "Configuration de l'alerte",
    description_optional: "Description (Optionnel)",
    priority_level: "Niveau de priorité",
    time_settings: "Paramètres de temps",
    start_time: "Heure de début",
    end_time: "Heure de fin",
    active_days: "Jours actifs",
    authorization_level: "Niveau d'autorisation",
    speed_settings: "Paramètres de vitesse",
    speed_limit: "Limite de vitesse (km/h)",
    tolerance: "Tolérance (km/h)",
    dwell_time_settings: "Paramètres de temps d'arrêt",
    max_dwell_time: "Temps d'arrêt maximum (minutes)",
    custom_alert_message: "Message d'alerte personnalisé (Optionnel)",
    dwell_threshold: "Seuil de temps d'arrêt (minutes)",
    timeout_duration: "Durée du délai (minutes)",
    enable_email_notifications: "Activer les notifications par email",
    select_locations: "Sélectionner les emplacements",
    select_locations_desc: "Choisissez les géozones et/ou itinéraires pour cette alerte",
    select_geofences: "Sélectionner les géozones",
    geofences_selected: "{{count}} sélectionnées",
    click_to_choose_areas: "Cliquez pour choisir les zones",
    select_routes: "Sélectionner les itinéraires",
    routes_selected: "{{count}} sélectionnés",
    click_to_choose_routes: "Cliquez pour choisir les itinéraires",
    selected_locations: "Emplacements sélectionnés",
    geofences: "Géozones",
    routes: "Itinéraires",
    remove_geofence: "Retirer la géozone",
    remove_route: "Retirer l'itinéraire",
    select_vehicles_alert: "Sélectionner les véhicules",
    select_vehicles_alert_desc: "Choisissez les véhicules concernés par cette alerte",
    vehicle_groups: "Groupes de véhicules",
    all_fleet: "Toute la flotte",
    trucks_only: "Camions uniquement",
    container_vehicles: "Véhicules conteneurs",
    light_vehicles: "Véhicules légers",
    individual_vehicles: "Véhicules individuels",
    active_alert: "Alerte active",
    alert_enabled_immediately: "L'alerte sera activée immédiatement",
    update_alert: "Mettre à jour l'alerte",
    loading_map_data: "Chargement des données cartographiques...",

    // Alert types
    location_alerts: "Alertes de localisation",
    safety_alerts: "Alertes de sécurité",
    route_alerts: "Alertes d'itinéraire",
    technical_alerts: "Alertes techniques",
    logistics_alerts: "Alertes logistiques",
    mission_alerts: "Alertes de mission",
    geofence_entry: "Entrée de géozone",
    speed_violation: "Excès de vitesse",
    route_deviation: "Déviation d'itinéraire",
    loading_timeout: "Délai de chargement",
    mission_timeout: "Délai de mission",

    // Geofence/Corridor
    geofence_selection: "Sélection de géozone",
    search_geofences: "Rechercher des géozones...",
    all_geofences: "Tous les types",
    circles: "Cercles",
    squares: "Carrés",
    polygons: "Polygones",
    route_selection: "Sélection d'itinéraire",
    search_routes: "Rechercher des itinéraires...",
    all_routes: "Tous les itinéraires",
    short_routes: "Itinéraires courts (<50km)",
    long_routes: "Itinéraires longs (>50km)",
    waypoints: "Points de passage",
    corridor: "Corridor",
    geofence: "Géozone",
    address: "Adresse",
    city: "Ville",
    radius: "Rayon",
    area: "Zone",
    loading_location: "Chargement de la localisation...",
    loading_route_info: "Chargement des informations d'itinéraire...",

    // Corridor Manager
    corridor_management_title: "Gestion des Corridors",
    trajectories: "Trajectoires",
    draw_route: "Tracer un itinéraire",
    add_geofence: "Ajouter une géozone",
    create_new_corridor: "Créer un nouveau corridor",
    edit_corridor: "Modifier le corridor",
    corridor_name: "Nom du corridor",
    corridor_name_placeholder: "Entrez le nom du corridor...",
    description_placeholder: "Entrez la description...",
    color: "Couleur",
    width: "Largeur",
    active_corridor: "Corridor actif",
    no_trajectories: "Aucune trajectoire trouvée",
    no_trajectories_desc: "Cliquez sur \"Tracer un itinéraire\" pour créer votre première trajectoire",
    no_geofences: "Aucune géozone trouvée",
    no_geofences_desc: "Utilisez les outils de dessin pour créer des géozones",
    editing: "En modification",
    entry: "Entrée",
    exit: "Sortie",
    route_updated: "Itinéraire mis à jour avec succès !",
    route_deleted: "Itinéraire supprimé avec succès !",
    geofence_updated: "Géozone mise à jour avec succès !",
    geofence_deleted: "Géozone supprimée avec succès !",
    delete_corridor_confirm: "Êtes-vous sûr de vouloir supprimer ce corridor ?",
    delete_geofence_confirm: "Êtes-vous sûr de vouloir supprimer cette géozone ?",
    error_updating_route: "Erreur lors de la mise à jour de l'itinéraire",
    error_deleting_route: "Erreur lors de la suppression de l'itinéraire",
    error_updating_geofence: "Erreur lors de la mise à jour de la géozone",
    error_deleting_geofence: "Erreur lors de la suppression de la géozone",

    // Vehicle Operations
    vehicle_management: "Gestion des Véhicules",
    vehicle_management_desc: "Gestion complète de la flotte : suivi des véhicules en temps réel",
    new_vehicle: "Nouveau véhicule",
    total_vehicles: "Total des véhicules",
    active_vehicles: "Actifs",
    in_maintenance: "En maintenance",
    alerts: "Alertes",
    average_age: "Âge moyen",
    overview: "Aperçu",
    fuel_tab: "Carburant",
    analytics: "Analytique",
    vehicle_attributes: "Attributs des véhicules",
    search_vehicles_detail: "Rechercher par code, plaque, marque, modèle ou client...",
    all_statuses: "Tous les statuts",
    all_vehicle_types: "Tous les types",
    trucks: "Camions",
    vans: "Fourgonnettes",
    pickups: "Pick-ups",
    containers: "Conteneurs",
    vehicle: "Véhicule",
    balises: "Balises",
    specifications: "Spécifications",
    not_assigned: "Non assigné",
    no_customer_code: "Pas de code client",
    no_balise: "Pas de balise",
    no_tracking: "Pas de suivi",
    consumption_na: "Consommation N/D",
    insurance_expiring: "Assurance expirant bientôt",
    service_overdue: "Révision en retard",
    service_due_soon: "Révision prochaine",
    ok: "OK",
    view_details: "Voir les détails",
    edit_vehicle: "Modifier le véhicule",
    delete_vehicle: "Supprimer le véhicule",
    delete_vehicle_confirm: "Êtes-vous sûr de vouloir supprimer le véhicule {{code}} ?",
    vehicle_deleted: "Véhicule {{code}} supprimé avec succès",
    error_deleting_vehicle: "Erreur lors de la suppression du véhicule",
    loading_vehicles_db: "Chargement des véhicules...",
    integrating_data: "Intégration des actifs, conteneurs et données de balises",
    maintenance_management: "Gestion de la maintenance",
    schedule_maintenance: "Planifier la maintenance",
    maintenance_history: "Historique de maintenance",
    no_maintenance: "Aucune maintenance trouvée",
    no_maintenance_records: "Aucun enregistrement de maintenance pour la période sélectionnée",
    fuel_management: "Gestion du carburant",
    record_fuel_fill: "Enregistrer un plein",
    fuel_history: "Historique des pleins",
    no_fuel_fills: "Aucun plein trouvé",
    no_fuel_records: "Aucun plein enregistré pour la période sélectionnée",
    analytics_reports: "Analytique et rapports",
    fleet_performance: "Performance de la flotte",
    average_utilization: "Utilisation moyenne",
    filter_by_period: "Filtrer par période",

    // Task Manager
    task_management: "Gestion des tâches",
    resources: "Ressources",
    list_view: "Liste",
    gantt_view: "Gantt",
    calendar_view: "Calendrier",
    add_task: "Ajouter une tâche",
    gantt_chart: "Vue Diagramme de Gantt",
    task: "Tâche",
    no_tasks: "Aucune tâche créée",
    no_tasks_desc: "Créez vos propres tâches pour cette mission",
    create_first_task: "Créer la première tâche",
    no_location: "Pas de localisation",
    progress: "Progression",
    start_task: "Démarrer la tâche",
    complete_task: "Terminer la tâche",
    edit_task: "Modifier la tâche",
    delete_task: "Supprimer la tâche",
    create_new_task: "Créer une nouvelle tâche",
    task_name: "Nom de la tâche",
    task_name_placeholder: "ex: Charger les conteneurs...",
    assign_staff_from_mission: "Personnel assigné à la mission",
    assign_vehicles_from_mission: "Véhicules assignés à la mission",
    assign_alerts_from_mission: "Alertes assignées à la mission",
    start_date: "Date de début",
    end_date: "Date de fin",
    duration_hours: "Durée (heures)",
    task_location: "Lieu de la tâche...",
    task_notes: "Instructions ou notes de la tâche...",
    update_task: "Mettre à jour la tâche",
    create_task: "Créer la tâche",
    task_created: "Tâche \"{{name}}\" créée",
    task_updated: "Statut de la tâche mis à jour",
    task_deleted: "Tâche supprimée",
    please_fill_task: "Veuillez remplir le nom de la tâche et assigner le personnel",
    no_staff_in_mission: "Aucun personnel assigné à cette mission",
    no_vehicles_in_mission: "Aucun véhicule assigné à cette mission",
    no_alerts_in_mission: "Aucune alerte assignée à cette mission",

    // Role Management
    role_management: "Gestion des rôles",

    // Days of week
    sun: "Dim",
    mon: "Lun",
    tue: "Mar",
    wed: "Mer",
    thu: "Jeu",
    fri: "Ven",
    sat: "Sam",

    // Priority levels
    low: "Faible",
    medium: "Moyen",
    high: "Élevé",
    urgent: "Urgent",
    critical: "Critique",
    public_level: "Public",
    restricted: "Restreint",
    private_level: "Privé",
    emergency: "Urgence",

    // Language
    language: "Langue",
    english: "English",
    french: "Français",

    // Panel labels for CompleteFleetDashboard
    balise_management: "Gestion des balises",
    customer_management: "Gestion des clients",
    container_management: "Gestion des conteneurs",
    asset_management: "Gestion des actifs",
    settings_management: "Paramètres",
    bm_dashboard: "Tableau de bord balises",
    balise_operations: "Opérations balises",
    balise_operations_desc: "Balises, clients, conteneurs, actifs, paramètres",

    // Balise management
    balise_mgmt_title: "Gestion des balises",
    balise_mgmt_subtitle: "Traceurs GPS pour véhicules et conteneurs",
    balise_tab_inventory: "Balises-IOTs",
    balise_tab_commands: "Commandes",
    balise_tab_sync: "Contrôle synchro",
    balise_tab_decommission: "Retrait",
    balise_tab_jointech_maxvision: "Jointech / MaxVision",
    balise_tab_jimi: "JIMI",
    balise_jimi_no_onboarded: "Aucune balise JIMI enregistrée pour le moment. Utilisez le catalogue ci-dessous pour en ajouter une.",
    balise_jimi_command_unavailable_tooltip: "Le verrouillage / déverrouillage des équipements JIMI n'est pas encore disponible (à venir avec le routage des commandes).",
    balise_jimi_onboarded_title: "Balises JIMI enregistrées",
    balise_jimi_onboarded_subtitle: "Équipements JIMI déjà déclarés dans le portail flotte.",
    balise_jimi_catalog_title: "Capteurs JIMI disponibles",
    balise_jimi_catalog_subtitle: "Équipements visibles côté constructeur TurboHive mais pas encore enregistrés ici.",
    balise_jimi_catalog_checked_at: "dernière vérification",
    balise_jimi_catalog_unreachable: "Le catalogue constructeur TurboHive est injoignable. Il se peut qu'aucun équipement JIMI ne soit en ligne pour le moment — réessayez plus tard.",
    balise_jimi_catalog_empty: "Aucun capteur JIMI signalé par TurboHive pour le moment. Dès qu'un équipement JIMI se connecte à la plateforme il apparaîtra ici, prêt à être enregistré.",
    balise_jimi_captors_upstream_error: "Catalogue TurboHive injoignable",
    balise_jimi_captors_load_failed: "Échec du chargement des capteurs JIMI",
    balise_jimi_col_imei: "IMEI / ID",
    balise_jimi_col_name: "Nom",
    balise_jimi_col_model: "Modèle",
    balise_jimi_col_status: "Statut constructeur",
    balise_jimi_col_last_seen: "Dernière activité",
    balise_jimi_onboard_action: "Enregistrer",
    balise_jimi_onboard_tooltip: "Enregistrer ce capteur JIMI comme balise (aperçu)",
    balise_jimi_onboard_coming_soon: "L'enregistrement des capteurs JIMI sera activé avec la prochaine version.",
    system_monitoring_title: "Supervision système",
    system_monitoring_subtitle: "Santé plateforme pour les intégrations constructeurs et les chaînes d'ingestion",
    system_monitoring_jimi_section: "Chaîne d'ingestion JIMI",
    system_monitoring_admin_only_title: "Accès administrateur requis",
    system_monitoring_admin_only_msg: "Ce panneau expose les métriques de santé côté plateforme. Demandez à un administrateur si vous avez besoin d'y accéder.",
    admin_shortcut_tooltip: "Ouvrir la supervision système",
    // P10 — inventaire balise universel : filtres par type d’appareil
    bm_filter_type_all: "Tous types",
    bm_filter_type_lock: "Cadenas connecté",
    bm_filter_type_gps: "Traqueur GPS",
    bm_filter_type_dashcam: "Dashcam",
    bm_filter_type_obd: "OBD",
    bm_filter_type_tag: "Tag BLE",
    bm_filter_brand_all: "Toutes marques",
    // (Clés du panneau adaptatif P10 supprimées ; les actions de
    // ligne déclenchent désormais directement les commandes
    // spécifiques. Les helpers smart-lock / dashcam / OBD / tag
    // vivent désormais dans des fenêtres d'actif dédiées.)
    // Flux Attach / Detach (réutilisé par la fiche balise universelle)
    jimi_attach_title: "Rattacher à un actif",
    jimi_attach_subtitle: "Choisissez l’actif auquel rattacher {{device}}",
    jimi_attach_search_placeholder: "Recherche par code, plaque, marque, modèle, client…",
    jimi_attach_count: "{{n}} actifs",
    jimi_attach_loading: "Chargement des actifs…",
    jimi_attach_empty: "Aucun actif ne correspond à votre recherche.",
    jimi_attach_current: "ACTUEL",
    jimi_attach_already_attached: "Cette balise est actuellement rattachée à {{asset}}. Confirmer la déplacera vers le nouvel actif.",
    jimi_attach_confirm: "Rattacher",
    jimi_attach_success: "Balise rattachée à {{asset}}",
    jimi_detach_success: "Balise détachée de l’actif",
    jimi_card_attach: "Rattacher à un actif",
    jimi_card_detach: "Détacher de l’actif",
    jimi_detach_failed: "Échec du détachement",
    // P8 / P10 — sélecteur asset-centré, agnostique de la marque
    peripheral_picker_title: "Ouvrir le suivi du périphérique",
    peripheral_picker_subtitle: "Cet actif possède plusieurs périphériques. Cliquez une carte pour en ouvrir une, ou cochez plusieurs cases pour en ouvrir plusieurs.",
    peripheral_picker_close: "Fermer",
    peripheral_picker_empty: "Aucun périphérique rattaché à cet actif.",
    peripheral_picker_online: "En ligne",
    peripheral_picker_offline: "Hors ligne",
    peripheral_picker_last_seen: "Vu pour la dernière fois",
    peripheral_picker_no_imei: "IMEI manquant — fenêtre indisponible.",
    peripheral_picker_select_aria: "Sélectionner le périphérique",
    peripheral_picker_count_selected: "{{count}} sélectionné(s)",
    peripheral_picker_clear: "Effacer",
    peripheral_picker_open_btn: "Ouvrir",
    asset_window_no_binding: "Sélectionnez un actif sur la carte ou la liste pour alimenter cette fenêtre.",
    // Fenêtre de serrure connectée
    asset_lock_default_name: "Serrure connectée",
    asset_lock_btn_seal: "Sceller",
    asset_lock_btn_unseal: "Desceller",
    asset_lock_btn_wakeup: "Réveiller",
    asset_lock_no_write: "Rôle Opérateur requis",
    asset_lock_tab_events: "Événements",
    asset_lock_tab_history: "Historique des commandes",
    asset_lock_tab_offline: "File d'attente hors ligne",
    asset_lock_refresh: "Rafraîchir",
    asset_lock_events_empty: "Aucun événement de serrure pour cet actif.",
    asset_lock_history_empty: "Aucune commande envoyée.",
    asset_lock_offline_empty: "Aucune commande en attente.",
    asset_lock_cancel: "Annuler",
    asset_lock_col_time: "Heure",
    asset_lock_col_event: "Événement",
    asset_lock_col_severity: "Sévérité",
    asset_lock_col_lock: "Serrure",
    asset_lock_col_cmdNo: "cmdNo",
    asset_lock_col_status: "Statut",
    asset_lock_col_ack: "Accusé",
    asset_lock_command_ok: "Commande {{action}} envoyée",
    asset_lock_command_warn: "{{action}} : {{msg}}",
    asset_lock_command_error: "{{action}} a échoué : {{msg}}",
    asset_lock_offline_cancel_ok: "Commande hors ligne annulée",
    asset_lock_offline_cancel_error: "Annulation impossible : {{msg}}",
    asset_lock_events_load_error: "Chargement des événements impossible : {{msg}}",
    asset_lock_history_load_error: "Chargement de l'historique impossible : {{msg}}",
    asset_lock_offline_load_error: "Chargement de la file impossible : {{msg}}",
    // Fenêtre dashcam
    asset_dashcam_default_name: "Dashcam IA",
    asset_dashcam_read_only: "Lecture seule — rôle Opérateur requis pour la vidéo.",
    asset_dashcam_tab_live: "Direct",
    asset_dashcam_tab_snapshot: "Photo",
    asset_dashcam_tab_recorded: "Enregistré",
    asset_dashcam_start_live: "Démarrer le direct",
    asset_dashcam_stop_live: "Arrêter le direct",
    asset_dashcam_capture: "Capturer",
    asset_dashcam_capture_now: "Capturer maintenant",
    asset_dashcam_live_idle: "Direct non démarré.",
    asset_dashcam_snapshot_empty: "Aucune capture pour le moment.",
    asset_dashcam_files_empty: "Aucun clip trouvé.",
    asset_dashcam_search: "Rechercher",
    asset_dashcam_play: "Lire",
    asset_dashcam_stop: "Arrêter",
    asset_dashcam_from: "De",
    asset_dashcam_to: "À",
    asset_dashcam_live_started: "Direct démarré",
    asset_dashcam_live_stopped: "Direct arrêté",
    asset_dashcam_live_start_error: "Démarrage impossible : {{msg}}",
    asset_dashcam_live_stop_error: "Arrêt impossible : {{msg}}",
    asset_dashcam_snapshot_ok: "Capture demandée",
    asset_dashcam_snapshot_error: "Capture impossible : {{msg}}",
    asset_dashcam_files_load_error: "Chargement des clips impossible : {{msg}}",
    asset_dashcam_playback_error: "Lecture impossible : {{msg}}",
    // Fenêtre OBD
    asset_obd_default_name: "Télémétrie OBD",
    asset_obd_refresh: "Rafraîchir",
    asset_obd_live_section: "Snapshot live",
    asset_obd_history_section: "Historique",
    asset_obd_no_data: "Pas de donnée",
    asset_obd_from: "De",
    asset_obd_to: "À",
    asset_obd_apply: "Appliquer",
    asset_obd_history_empty: "Aucun enregistrement OBD sur cette plage.",
    asset_obd_col_time: "Heure",
    asset_obd_prev: "Précédent",
    asset_obd_next: "Suivant",
    asset_obd_page: "Page {{page}}",
    asset_obd_latest_error: "Chargement OBD live impossible : {{msg}}",
    asset_obd_history_error: "Chargement de l'historique OBD impossible : {{msg}}",
    asset_obd_acc: "ACC",
    asset_obd_speed: "Vitesse",
    asset_obd_engine_speed: "Régime moteur",
    asset_obd_fuel_level: "Niveau carburant",
    asset_obd_battery_voltage: "Tension batterie",
    asset_obd_coolant_temp: "Température liquide refr.",
    asset_obd_intake_air_temp: "Température air admission",
    asset_obd_throttle_pos: "Position papillon",
    asset_obd_throttle_abs_pos: "Position papillon absolue",
    asset_obd_manifold_pressure: "Pression collecteur",
    asset_obd_mass_air_flow: "Débit d'air",
    asset_obd_instant_fuel: "Conso. instantanée",
    asset_obd_avg_fuel: "Conso. moyenne",
    asset_obd_total_fuel: "Conso. totale",
    asset_obd_engine_runtime: "Temps moteur",
    asset_obd_odometer: "Odomètre",
    asset_obd_cum_mileage: "Kilométrage cumulé",
    asset_obd_vehicle_type: "Type de véhicule",
    // Fenêtre tags
    asset_tags_default_name: "Tags appairés",
    asset_tags_refresh: "Rafraîchir",
    asset_tags_empty: "Aucun tag appairé signalé par ce périphérique.",
    asset_tags_history_empty: "Aucun historique.",
    asset_tags_col_time: "Heure",
    asset_tags_col_value: "Valeur",
    asset_tags_col_rssi: "RSSI",
    asset_tags_col_battery: "Batterie",
    asset_tags_load_error: "Chargement des tags impossible : {{msg}}",
    asset_tags_history_error: "Chargement de l'historique du tag impossible : {{msg}}",
    balise_stat_total: "Total",
    balise_stat_active: "Actifs",
    balise_stat_low_battery: "Batterie faible",
    balise_stat_offline: "Hors ligne",
    balise_search_placeholder: "Rechercher code serrure, appareil, client...",
    balise_filter_assignment: "Statut d'affectation",
    balise_filter_assignment_all: "Tous",
    balise_filter_assignment_assigned: "Affectés",
    balise_filter_assignment_unassigned: "Non affectés",
    balise_filter_brand: "Marque",
    balise_filter_brand_all: "Toutes les marques",
    balise_col_lock_code: "Code serrure",
    balise_col_brand: "Marque",
    balise_col_battery: "Batterie",
    balise_col_status: "Statut",
    balise_col_customer: "Client",
    balise_col_actions: "Actions",
    balise_action_assign: "Affecter",
    balise_action_unassign: "Retirer l'affectation",
    balise_action_view_details: "Voir les détails",
    balise_pagination_page: "Page {{page}} sur {{total}}",
    balise_pagination_prev: "Précédent",
    balise_pagination_next: "Suivant",
    balise_no_balises: "Aucune balise",
    balise_load_failed: "Échec du chargement des balises",
    balise_stats_failed: "Échec du chargement des statistiques",
    balise_commands_select: "Sélectionner une balise",
    balise_commands_seal: "Sceller",
    balise_commands_unseal: "Désceller",
    balise_commands_change_mode: "Changer le mode appareil",
    balise_mode_normal: "Normal",
    balise_mode_trip: "Mode trajet",
    balise_mode_maxvision_only: "Le mode appareil est disponible uniquement pour MaxVision.",
    balise_commands_select_first: "Sélectionnez d'abord une balise",
    balise_sync_select_lock: "Code serrure",
    balise_sync_select_placeholder: "Choisir le code serrure",
    balise_sync_status_title: "État de synchro",
    balise_sync_history_title: "Historique de synchro",
    balise_sync_activate: "Activer",
    balise_sync_deactivate: "Désactiver",
    balise_sync_maintain: "Maintenance",
    balise_sync_load: "Charger les données",
    balise_sync_loading: "Chargement synchro…",
    balise_sync_no_selection: "Sélectionnez un code serrure pour voir l'état",
    balise_decom_select: "Sélectionner la balise à retirer",
    balise_decom_warning: "Le retrait est définitif. L'appareil sera retiré de l'inventaire actif et l'opération est irréversible.",
    balise_decom_confirm: "Retirer l'appareil",
    balise_decom_confirm_prompt: "Saisissez le code serrure pour confirmer : {{code}}",
    balise_assign_modal_title: "Affecter à un client",
    balise_assign_container_modal_title: "Affecter à un conteneur",
    balise_search_container_placeholder: "Rechercher par code, type, propriétaire, statut…",
    balise_container_count: "{{n}} conteneurs",
    balise_no_match_containers: "Aucun conteneur ne correspond à votre recherche.",
    balise_assign_customer_id: "ID client",
    balise_assign_customer_name: "Nom du client",
    balise_assign_customer_id_placeholder: "ID client numérique",
    balise_assign_customer_name_placeholder: "Nom affiché",
    balise_details_title: "Détails balise",
    balise_field_universal_id: "ID universel",
    balise_field_device_name: "Nom d'appareil",
    balise_field_last_seen: "Dernière activité",
    balise_field_assignment: "Affectation",
    balise_battery_unknown: "Inconnu",
    balise_status_unknown: "Inconnu",
    balise_customer_unassigned: "Non affecté",
    balise_action_in_progress: "Traitement…",
    balise_unassign_confirm: "Retirer l'affectation client de cette balise ?",
    balise_assign_success: "Balise affectée avec succès",
    balise_assign_failed: "Échec de l'affectation",
    balise_unassign_success: "Affectation retirée",
    balise_unassign_failed: "Échec du retrait d'affectation",
    balise_seal_success: "Commande de fermeture envoyée. Le cadenas se ferme quand l'appareil répond.",
    balise_seal_failed: "Échec de la commande sceller",
    balise_unseal_success: "Commande d'ouverture envoyée. Le cadenas s'ouvre quand l'appareil répond.",
    balise_unseal_failed: "Échec de la commande désceller",
    balise_mode_success: "Mode appareil mis à jour",
    balise_mode_failed: "Échec du changement de mode",
    balise_sync_action_success: "Action de synchro terminée",
    balise_sync_action_failed: "Échec de l'action de synchro",
    balise_decom_success: "Balise retirée",
    balise_decom_failed: "Échec du retrait",
    balise_decom_mismatch: "Le code serrure ne correspond pas",
    balise_decom_reason: "Motif",
    balise_decom_reason_placeholder: "Motif du retrait…",
    balise_decom_confirm_title: "Retirer la balise",
    balise_decom_confirm_msg_v2: "Retirer {{id}} ? Cette action est définitive.",
    balise_error_generic: "Une erreur s'est produite",
    balise_refresh_list: "Actualiser la liste",
    // 9-button row + new dialogs (legacy parity)
    balise_action_sim: "Gérer la SIM",
    balise_action_trajectory: "Trajectoire",
    balise_assign_modal_title_v2: "Affecter la balise",
    balise_assign_modal_subtitle: "Choisissez un conteneur ou un actif.",
    balise_assign_card_containers: "Conteneurs disponibles",
    balise_assign_card_assets: "Actifs disponibles",
    balise_assign_card_create: "Créer un nouvel actif ou conteneur",
    balise_assign_create_hint: "Aucune cible adaptée ? Ouvrez la fenêtre Gestion des clients pour créer un nouvel actif ou conteneur, puis revenez affecter la balise.",
    balise_assigned_short: "Balise",
    balise_no_assets: "Aucun actif disponible",
    balise_no_match_assets: "Aucun actif ne correspond à votre recherche.",
    balise_search_asset_placeholder: "Rechercher par nom, type, identifiant, lieu…",
    balise_assign_confirm_title: "Confirmer l'affectation",
    balise_assign_confirm_container: "Cette balise sera affectée au conteneur sélectionné.",
    balise_assign_confirm_asset: "Cette balise sera affectée à l'actif sélectionné.",
    balise_assign_button: "Affecter",
    balise_unassign_confirm_title: "Confirmer le désaffectage",
    balise_unassign_confirm_msg_v2: "Désaffecter {{id}} de {{name}} ?",
    balise_unassign_checking_sync: "Vérification du statut de synchro…",
    sync_stop_message: "La synchro est ACTIVE pour {{id}}. Que faut-il faire ?",
    sync_stop_keep: "Garder la synchro, désaffecter",
    sync_stop_stop: "Arrêter la synchro, désaffecter",
    sync_widget_title: "Synchronisation des données",
    sync_widget_refresh: "Actualiser le statut de synchro",
    sync_widget_refresh_short: "Actualiser",
    sync_widget_unavailable: "Statut de synchro indisponible pour cette balise.",
    sync_widget_activated_at: "Activée",
    sync_widget_maintained_at: "Maintenue",
    detail_card_device: "Informations de l'appareil",
    detail_card_assignment: "Affectation",
    detail_card_technical: "Technique",
    detail_card_location: "Localisation",
    detail_field_container_id: "ID conteneur",
    detail_field_asset_id: "ID actif",
    detail_field_coords: "Coordonnées",
    detail_location_hint: "Utilisez les icônes GPS ou Trajectoire pour visualiser sur une carte.",
    detail_location_none: "Aucune donnée GPS pour le moment.",
    balise_field_device_type: "Type d'appareil",
    // SIM picker (replaces legacy "coming soon" toast)
    sim_assign_modal_title: "Gérer la SIM",
    sim_assign_pick: "Choisissez une SIM à affecter à cette balise.",
    sim_assign_pick_replacement: "Choisissez une SIM de remplacement, ou détachez l'actuelle.",
    sim_assign_search_placeholder: "Rechercher par ICCID, téléphone, opérateur, pays…",
    sim_assign_count: "{{n}} cartes SIM",
    sim_assign_load_failed: "Échec du chargement des SIM",
    sim_assign_none: "Aucune carte SIM disponible.",
    sim_assign_no_match: "Aucune SIM ne correspond à votre recherche.",
    sim_assign: "Affecter la SIM",
    sim_replace: "Remplacer la SIM",
    sim_assign_success: "SIM affectée à la balise",
    sim_assign_failed: "Échec de l'affectation SIM",
    sim_unassign_success: "SIM détachée de la balise",
    sim_unassign_failed: "Échec du détachement SIM",
    sim_current_label: "Actuellement attachée",
    sim_current_badge: "Actuelle",
    sim_data_left: "{{used}}/{{limit}} Mo",
    sim_detach: "Détacher",
    // Map modal (Location + Trajectory)
    map_modal_title_location: "Position GPS",
    map_modal_title_trajectory: "Trajectoire",
    map_modal_tab_location: "Position",
    map_modal_tab_trajectory: "Trajectoire",
    map_modal_copy: "Copier",
    map_modal_copy_coords: "Copier les coordonnées",
    map_modal_open_external: "Ouvrir dans Google Maps",
    map_modal_iframe_title: "Aperçu carte",
    map_modal_iframe_failed: "Échec du chargement de la carte",
    map_modal_no_coords: "Pas encore de coordonnées GPS pour cette balise.",
    map_modal_no_trajectory: "Aucune donnée de trajectoire pour cette période.",
    map_modal_no_data: "Aucune donnée de trajectoire pour cet appareil.",
    map_modal_loading_trajectory: "Chargement de la trajectoire…",
    map_modal_widened_window: "Aucune donnée pour {{requested}} — affichage de {{used}} à la place.",
    map_modal_has_data_elsewhere: "Aucune donnée dans {{requested}}. L'appareil a {{n}} points au total — essayez une fenêtre plus large.",
    map_modal_fix_at: "Position à",
    map_modal_open_in_tracking: "Ouvrir dans la carte Fleet",
    map_modal_open_in_tracking_unassigned: "Cette balise n'est affectée à aucun actif — rien à afficher sur la carte Fleet.",
    cockpit_title: "Cockpit véhicule",
    cockpit_title_bound: "Cockpit — {{name}}",
    cockpit_subtitle: "Toutes les balises et capteurs rattachés à cet actif",
    cockpit_empty: "Aucune balise ou capteur n'est encore affecté à ce véhicule. Affectez-en un dans Balise Management.",
    cockpit_no_binding: "Sélectionnez un véhicule et ouvrez son cockpit pour voir balises et capteurs.",
    cockpit_select_vehicle: "Sélectionnez d'abord un véhicule",
    cockpit_captors: "Capteurs & IO",
    cockpit_ble: "Capteurs BLE (EYE / tags)",
    map_modal_range_1h: "Dernière heure",
    map_modal_range_6h: "6 dernières heures",
    map_modal_range_24h: "24 dernières heures",
    map_modal_range_3d: "3 derniers jours",
    map_modal_range_7d: "Semaine dernière",
    map_modal_range_30d: "Mois dernier",
    map_modal_range_3m: "3 derniers mois",
    map_modal_stat_points: "Points",
    map_modal_stat_avg_speed: "Vitesse moy.",
    map_modal_stat_max_speed: "Vitesse max",
    map_modal_stat_window: "Fenêtre",

    // Asset & Container Modal (acm)
    acm: {
      assetsAndContainers: "Actifs & Conteneurs",
      containers: "Conteneurs",
      assets: "Actifs",
      balises: "balise(s)",
      add: "Ajouter",
      noContainers: "Aucun conteneur",
      noAssets: "Aucun actif",
      addContainer: "Ajouter un conteneur",
      editContainer: "Modifier le conteneur",
      addAsset: "Ajouter un actif",
      editAsset: "Modifier l'actif",
      reference: "Référence équipement",
      referenceRequired: "La référence est requise",
      type: "Type de conteneur",
      status: "Statut",
      owner: "Propriétaire",
      origin: "Origine",
      destination: "Destination",
      bookingRef: "Référence réservation",
      assetName: "Nom de l'actif",
      assetType: "Type",
      identifier: "Identifiant",
      assetFieldsRequired: "Le nom et l'identifiant sont requis",
      location: "Emplacement",
      description: "Description",
      update: "Mettre à jour",
      create: "Créer",
      containerCreated: "Conteneur créé",
      containerUpdated: "Conteneur mis à jour",
      assetCreated: "Actif créé",
      assetUpdated: "Actif mis à jour",
      linked: "Lié",
      unlinked: "Non lié",
      assigned: "Affecté",
      balisesFor: "Balises de",
      noBalises: "Aucune balise trouvée",
      cannotDelete: "Impossible de supprimer",
      unassignFirst: "Désaffecter toutes les balises avant de supprimer ce conteneur.",
      allUnassigned: "Toutes les balises désaffectées !",
      proceedDelete: "Procéder à la suppression",
      unassign: "Désaffecter",
      baliseUnassigned: "Balise désaffectée",
      confirmDeleteTitle: "Confirmer la suppression",
      confirmDeleteMsg: "Supprimer {{type}} « {{name}} » ? Cette action est irréversible.",
    },
    telemetryAlerts: {
      newRule: "Nouvelle règle d’alerte",
      editRule: "Modifier la règle d’alerte",
      editorSubtitle: "Définissez l’événement, les conditions, l’horaire, les actions et la portée.",
      trigger: "Déclencheur",
      triggerHint: "Choisissez l’événement réel ou le signal capteur qui déclenche l’alerte.",
      conditions: "Paramètres et conditions",
      conditionsHint: "Définissez le seuil, la durée et la condition de localisation éventuelle.",
      time: "Horaire",
      timeHint: "Active en permanence par défaut. Limitez l’horaire uniquement si nécessaire.",
      actions: "Actions et diffusion",
      actionsHint: "Choisissez les canaux et les destinataires internes ou externes.",
      appliesTo: "Valable pour",
      appliesToHint: "Sélectionnez le client et la portée opérationnelle. Les cibles incompatibles sont bloquées.",
      general: "Général",
      generalHint: "Nommez, expliquez et priorisez cette règle opérationnelle.",
      operator: "Condition",
      value: "Valeur",
      delay: "La condition doit persister",
      cooldown: "Délai avant répétition",
      eventExplainer: "Cette règle se déclenche uniquement lorsqu’un événement fournisseur vérifié est normalisé vers ce signal.",
      locationRequired: "Zone / trajectoire *",
      locationOptional: "Uniquement dans une zone (facultatif)",
      chooseOnMap: "Choisir sur la carte",
      zoneRequired: "Sélectionnez au moins une zone opérationnelle.",
      noLocationRestriction: "Aucune restriction de localisation.",
      scheduleEnabled: "Horaire limité",
      alwaysActive: "Toujours active — 24 h/24",
      startDate: "Date de début (facultatif)",
      endDate: "Date de fin (facultatif)",
      timezone: "Fuseau horaire",
      from: "De",
      to: "À",
      portalRecipients: "Destinataires du portail",
      externalRecipients: "Destinataires externes (aucun compte requis)",
      noPortalRecipients: "Aucun utilisateur avec une adresse e-mail dans cette portée.",
      notConfigured: "Non configuré",
      allCustomers: "Tous les clients",
      selectFleet: "Sélectionner une flotte…",
      selectMission: "Sélectionner une mission active…",
      selectVehicleType: "Sélectionner un type de véhicule…",
      selectDeviceType: "Sélectionner un type d’appareil…",
      allDevicesOfType: "Tous les appareils de ce type",
      selected: "sélectionné(s)",
      noSignal: "Aucun signal actuel",
      partial: "Couverture partielle",
      noTargetData: "Aucun instantané télémétrique actuel pour cette portée.",
      coverage: "{{supported}} véhicule(s) sur {{total}} transmettent actuellement ce signal.",
      unsupportedScope: "Les cibles sélectionnées ne transmettent pas ce signal.",
      ruleName: "Nom de la règle *",
      severity: "Sévérité",
      info: "Information",
      critical: "Critique",
      description: "Description",
      descriptionPlaceholder: "Expliquez l’action opérationnelle attendue lorsque l’alerte se déclenche.",
      liveSummary: "Résumé de la règle",
      advancedBehavior: "Comportement avancé",
      repeatWhileActive: "Autoriser les répétitions tant que l’alerte reste active",
      notifyRecovery: "Notifier les destinataires lors du retour à la normale",
      createRule: "Créer la règle",
      ruleCreated: "Règle d’alerte créée",
      ruleUpdated: "Règle d’alerte mise à jour",
      saveFailed: "Impossible d’enregistrer la règle d’alerte.",
      invalidRecipient: "Saisissez un e-mail, une URL HTTPS ou un numéro international.",
      zoneRefreshFailed: "La zone a été enregistrée, mais la liste n’a pas pu être actualisée.",
      drawGeofence: "Dessiner une nouvelle zone",
      drawTrajectory: "Dessiner une nouvelle trajectoire",
      selectGeofences: "Sélectionner les zones",
      selectTrajectories: "Sélectionner les trajectoires",
      newGeofence: "Nouvelle zone",
      newTrajectory: "Nouvelle trajectoire",
      categories: {
        LOCATION: "Localisation",
        DRIVING: "Conduite",
        DEVICE_HEALTH: "État de l’appareil",
        SECURITY: "Sécurité",
        ENVIRONMENT: "Environnement",
        OBD: "OBD / véhicule",
        TAGS: "Tags / périphériques",
        LOGISTICS: "Logistique",
      },
      scope: {
        all: "Tous les véhicules",
        fleet: "Flotte",
        vehicles: "Véhicules",
        mission: "Mission",
        vehicleType: "Type de véhicule",
        deviceType: "Appareil / capteur",
      },
      days: { Sun: "Dim", Mon: "Lun", Tue: "Mar", Wed: "Mer", Thu: "Jeu", Fri: "Ven", Sat: "Sam" },
      triggers: {
        GEOFENCE_ENTRY: "Entrée dans une zone",
        GEOFENCE_EXIT: "Sortie d’une zone",
        CORRIDOR_DEVIATION: "Écart de trajectoire",
        DWELL_TIME: "Temps dans une zone",
        STOPPED_TOO_LONG: "Arrêt trop long",
        SPEED_THRESHOLD: "Seuil de vitesse",
        BATTERY_LOW: "Batterie faible",
        SIGNAL_LOW: "Signal faible",
        DEVICE_OFFLINE: "Appareil hors ligne",
        GPS_SIGNAL_LOST: "Signal GPS perdu",
        LOW_BATTERY_EVENT: "Alarme de batterie faible",
        POWER_LOSS: "Alimentation externe coupée",
        LOCK_STATE: "État du verrou ou du scellé",
        TAMPER: "Sabotage détecté",
        VIBRATION: "Vibration détectée",
        SOS_PANIC: "SOS / panique",
        TEMPERATURE_THRESHOLD: "Seuil de température",
        HUMIDITY_THRESHOLD: "Seuil d’humidité",
        IGNITION_STATE: "État du contact",
        RPM_THRESHOLD: "Régime moteur",
        COOLANT_TEMPERATURE: "Température du liquide de refroidissement",
        FUEL_LEVEL: "Niveau de carburant faible",
        ODOMETER_THRESHOLD: "Seuil kilométrique",
        DIAGNOSTIC_EVENT: "Défaut diagnostic",
        TAG_BATTERY_LOW: "Batterie du tag faible",
        TAG_TEMPERATURE: "Température du tag",
        TAG_MISSING: "Tag absent",
      },
    },
    settings_tab_mail: "Centre e-mail",
    communications: {
      title: "Centre e-mail de la plateforme",
      description: "Configurez l’envoi de la plateforme, les modèles transactionnels et les newsletters avec consentement.",
      sections: {
        smtp: "Serveur e-mail",
        smtpDescription: "Configuration guidée de votre prestataire, expéditeur et test d’envoi.",
        branding: "Identité visuelle",
        brandingDescription: "Logo, couleur et pied de page appliqués à tous les messages.",
        templates: "Messages",
        templatesDescription: "Modifiez le contenu de chaque e-mail automatique, en français et en anglais.",
        newsletters: "Newsletters",
        newslettersDescription: "Créez, planifiez et analysez les campagnes de la plateforme.",
      },
      validation: {
        host: "Saisissez le nom d’hôte SMTP.",
        port: "Saisissez un port compris entre 1 et 65535.",
        email: "Saisissez une adresse e-mail valide.",
        smtpPassword: "Un mot de passe est requis lorsqu’un utilisateur SMTP est configuré.",
      },
      smtp: {
        configured: "Serveur e-mail configuré",
        notConfigured: "Serveur e-mail non configuré",
        completeSettings: "Complétez puis vérifiez les paramètres SMTP ci-dessous.",
        updated: "Mis à jour",
        connected: "Configuré",
        required: "Requis",
        passwordStored: "Mot de passe enregistré",
        noPassword: "Aucun mot de passe",
        host: "Hôte SMTP",
        port: "Port SMTP",
        username: "Nom d’utilisateur",
        password: "Mot de passe",
        replacePassword: "Remplacer le mot de passe",
        keepPassword: "Laissez vide pour conserver le mot de passe enregistré",
        senderName: "Nom de l’expéditeur",
        senderAddress: "Adresse de l’expéditeur",
        replyTo: "Adresse de réponse",
        implicitTls: "TLS implicite",
        tlsHint: "Activez pour le port 465 ; désactivez pour STARTTLS, généralement le port 587.",
        saveVerify: "Enregistrer et vérifier la connexion",
        saved: "Les paramètres SMTP ont été vérifiés et enregistrés.",
        steps: {
          provider: "Prestataire",
          credentials: "Identifiants",
          sender: "Expéditeur",
        },
        chooseProvider: "Choisissez votre prestataire e-mail.",
        beforeYouStart: "Ce que ce prestataire exige",
        providerDocs: "Instructions du prestataire",
        ownServer: "Votre propre serveur",
        showAdvanced: "Afficher l’hôte et le port",
        hideAdvanced: "Masquer l’hôte et le port",
        usernameEmail: "Utilisez l’adresse e-mail complète du compte expéditeur.",
        usernameLogin: "Utilisez l’identifiant SMTP fourni par le prestataire.",
        usernameFixed: "Ce prestataire impose exactement cet identifiant.",
        senderNameHint: "Le nom que les destinataires voient dans leur boîte de réception.",
        replyToHint: "Où arrivent les réponses. Laissez vide pour utiliser l’adresse d’expédition.",
        fixFields: "Corrigez d’abord les champs signalés.",
        back: "Retour",
        next: "Continuer",
        sendTest: "Envoyer un test",
        testHint: "Utilise la connexion SMTP enregistrée et le modèle de test SMTP.",
        verifyDelivery: "Envoyer le test",
        testSent: "E-mail de test envoyé.",
      },
      mailErrors: {
        MAIL_UNCONFIGURED: {
          title: "Le serveur e-mail n’est pas configuré",
          message: "Configurez un hôte SMTP, un expéditeur et les identifiants avant tout envoi.",
          suggestion1: "Saisissez les paramètres SMTP fournis par votre prestataire.",
          suggestion2: "Enregistrez les paramètres puis relancez le test.",
        },
        MAIL_DNS_FAILED: {
          title: "Hôte SMTP introuvable",
          message: "Le nom d’hôte SMTP n’a pas pu être résolu.",
          suggestion1: "Vérifiez la saisie du nom d’hôte.",
          suggestion2: "Vérifiez que le serveur API Fleet dispose d’un accès DNS.",
        },
        MAIL_CONNECTION_REFUSED: {
          title: "Connexion SMTP refusée",
          message: "Le serveur est joignable mais n’accepte pas les connexions SMTP sur ce port.",
          suggestion1: "Vérifiez le port SMTP.",
          suggestion2: "Vérifiez le pare-feu ou la liste blanche d’adresses IP du prestataire.",
        },
        MAIL_CONNECTION_TIMEOUT: {
          title: "Délai de connexion SMTP dépassé",
          message: "Le serveur e-mail n’a pas répondu à temps.",
          suggestion1: "Vérifiez le réseau et le pare-feu.",
          suggestion2: "Confirmez l’hôte et le port auprès du prestataire.",
        },
        MAIL_TLS_MISMATCH: {
          title: "Le réglage de chiffrement SMTP ne correspond pas",
          message: "Le mode TLS sélectionné n’est pas pris en charge sur ce port SMTP.",
          suggestion1: "Utilisez TLS implicite pour le port 465.",
          suggestion2: "Utilisez STARTTLS pour le port 587.",
        },
        MAIL_CERTIFICATE_INVALID: {
          title: "Le certificat SMTP n’a pas pu être vérifié",
          message: "Le serveur e-mail a présenté un certificat invalide ou non approuvé.",
          suggestion1: "Vérifiez que le nom d’hôte correspond au certificat.",
          suggestion2: "Demandez au prestataire de réparer la chaîne de certificats.",
        },
        MAIL_AUTH_FAILED: {
          title: "Échec de l’authentification SMTP",
          message: "Le serveur e-mail a refusé le nom d’utilisateur ou le mot de passe.",
          suggestion1: "Saisissez à nouveau l’utilisateur et le mot de passe SMTP.",
          suggestion2: "Utilisez un mot de passe d’application si le prestataire l’exige.",
        },
        MAIL_SENDER_REJECTED: {
          title: "Adresse d’expéditeur refusée",
          message: "Le serveur SMTP n’autorise pas cet expéditeur ou ce relais.",
          suggestion1: "Utilisez une adresse d’expéditeur vérifiée.",
          suggestion2: "Vérifiez les autorisations de relais du compte SMTP.",
        },
        MAIL_RECIPIENT_REJECTED: {
          title: "Adresse du destinataire refusée",
          message: "Le serveur SMTP a refusé l’adresse du destinataire.",
          suggestion1: "Vérifiez l’adresse du destinataire.",
          suggestion2: "Vérifiez que son domaine accepte les e-mails.",
        },
        MAIL_RATE_LIMITED: {
          title: "Limite d’envoi du prestataire atteinte",
          message: "Le prestataire a temporairement limité les envois.",
          suggestion1: "Attendez avant de réessayer.",
          suggestion2: "Consultez le quota d’envoi du prestataire.",
        },
        MAIL_TEMPORARY_FAILURE: {
          title: "Prestataire e-mail temporairement indisponible",
          message: "Le prestataire a renvoyé une erreur SMTP temporaire.",
          suggestion1: "Réessayez plus tard.",
          suggestion2: "Consultez la page d’état du prestataire.",
        },
        MAIL_VALIDATION_FAILED: {
          title: "Les paramètres e-mail sont invalides",
          message: "Corrigez les paramètres signalés puis réessayez.",
          suggestion1: "Vérifiez tous les champs obligatoires.",
          suggestion2: "Vérifiez les adresses d’expéditeur et de réponse.",
        },
        MAIL_UNKNOWN: {
          title: "Échec de l’envoi",
          message: "Le serveur e-mail n’a pas pu terminer la demande.",
          suggestion1: "Vérifiez les paramètres SMTP.",
          suggestion2: "Demandez à un administrateur serveur de consulter les journaux de l’API Fleet.",
        },
      },
      categories: {
        ACCOUNT: "Compte",
        SECURITY: "Sécurité",
        ALERT: "Alertes flotte",
        NEWSLETTER: "Newsletter",
        SYSTEM: "Système",
      },
      blocks: {
        empty: "Ce message n’a pas encore de contenu. Ajoutez un bloc ci-dessous.",
        insertData: "Insérer une donnée",
        insertHint: "Cliquez dans un champ de texte, puis ajoutez une valeur qui sera remplie à l’envoi.",
        addItem: "Ajouter une puce",
        addRow: "Ajouter une ligne",
        factLabel: "Libellé",
        factValue: "Valeur",
        codeLabel: "Libellé au-dessus du code",
        codeValue: "Code",
        buttonLabel: "Texte du bouton",
        dividerHint: "Trace une ligne de séparation.",
        imageUrl: "Adresse de l’image (https://…)",
        imageAlt: "Description pour les personnes qui ne la voient pas",
        imageCaption: "Légende (facultatif)",
        imageLink: "Ouvrir cette adresse au clic (facultatif)",
        imageHint: "Collez l’adresse web d’une image hébergée en ligne.",
        moveUp: "Monter",
        moveDown: "Descendre",
        remove: "Supprimer",
        types: {
          paragraph: "Texte",
          bullets: "Liste à puces",
          callout: "Encadré",
          code: "Code en grand",
          facts: "Liste de détails",
          button: "Bouton",
          image: "Image",
          divider: "Séparateur",
        },
        tones: {
          info: "Neutre",
          success: "Positif",
          warning: "Attention",
          critical: "Urgent",
        },
      },
      templates: {
        events: "Modèles d’événements",
        empty: "Aucun modèle e-mail disponible.",
        enabled: "Activé",
        disabled: "Désactivé",
        savedPreviewHint: "L’aperçu et le test utilisent la version enregistrée.",
        subject: "Objet",
        heading: "Titre dans le message",
        preheader: "Résumé dans la boîte de réception",
        preheaderHint: "Affiché à côté de l’objet dans la plupart des messageries. Moins de 90 caractères.",
        body: "Corps du message",
        content: "Contenu du message",
        contentHint: "Composez le message par blocs. L’aperçu à droite se met à jour pendant la saisie.",
        layout: "Mise en page",
        layoutHint: "Choisissez la présentation de ce message.",
        actionLabel: "Libellé du bouton d’action",
        actionLabelEmpty: "Laissez vide pour ne pas afficher de bouton",
        toggleTheme: "Basculer entre le mode clair et sombre",
        saveBeforeTest: "Enregistrez vos modifications avant d’envoyer un test.",
        testHint: "Envoie ce message avec des données d’exemple, à partir de la version enregistrée.",
        variables: "Variables disponibles",
        variableHint: "Choisissez un champ cible puis insérez une variable sûre.",
        reset: "Rétablir le modèle",
        resetConfirm: "Rétablir le modèle par défaut de cette langue ?",
        resetDone: "Modèle par défaut rétabli.",
        resetFailed: "Impossible de rétablir le modèle.",
        save: "Enregistrer le modèle",
        saved: "Modèle enregistré.",
        saveFailed: "Impossible d’enregistrer le modèle.",
        preview: "Aperçu",
        previewSubject: "Objet généré",
        previewFailed: "Impossible de générer l’aperçu.",
        saveBeforePreview: "Enregistrez les modifications avant l’aperçu.",
        sendTest: "Tester le modèle sélectionné",
        send: "Envoyer le test",
        testSent: "Test du modèle envoyé.",
        testFailed: "Impossible d’envoyer le test du modèle.",
        loadFailed: "Impossible de charger les modèles e-mail.",
      },
      branding: {
        intro: "Ces réglages apparaissent dans tous les messages envoyés par la plateforme.",
        appName: "Nom de la plateforme",
        appNameHint: "Utilisé dans les objets, les boutons et le pied de page.",
        logoUrl: "Adresse du logo",
        logoUrlHint: "Une adresse https publique vers un PNG ou JPEG. Laissez vide pour afficher le nom en texte.",
        accent: "Couleur principale",
        accentHint: "Utilisée pour les boutons et les mises en valeur.",
        theme: "Apparence",
        themeHint: "Le mode sombre garde un texte clair sur fond sombre dans tous les messages.",
        themes: { LIGHT: "Clair", DARK: "Sombre" },
        supportEmail: "Adresse d’assistance",
        supportEmailHint: "Affichée dans le pied de page pour que les destinataires sachent où demander de l’aide.",
        footerNote: "Note de pied de page",
        footerNoteHint: "Par exemple, la raison pour laquelle le destinataire reçoit ce message.",
        postalAddress: "Adresse postale",
        postalAddressHint: "Exigée par les règles anti-spam pour les newsletters.",
        preview: "Aperçu en direct",
        save: "Enregistrer l’identité visuelle",
        saved: "Identité visuelle enregistrée.",
        saveFailed: "Impossible d’enregistrer l’identité visuelle.",
        loadFailed: "Impossible de charger l’identité visuelle.",
      },
      variables: {
        appName: "Nom de la plateforme",
        appUrl: "Adresse web de la plateforme",
        recipientName: "Nom affiché du destinataire",
        invitationUrl: "Lien d’acceptation de l’invitation",
        resetUrl: "Lien de réinitialisation du mot de passe",
        verificationUrl: "Lien de vérification de l’e-mail",
        unsubscribeUrl: "Lien signé de désinscription",
        actionUrl: "Lien d’action principal",
        expiresIn: "Durée de validité du lien ou du code",
        code: "Code de vérification à usage unique",
        changedAt: "Date et heure du changement de mot de passe",
        event: "Description de l’événement de sécurité",
        eventAt: "Date et heure de l’événement",
        ipAddress: "Adresse IP source",
        newEmail: "Nouvelle adresse e-mail en attente",
        status: "Nouvel état du compte",
        changedBy: "Administrateur ayant effectué le changement",
        alertType: "Type d’alerte flotte",
        vehicleCode: "Identifiant du véhicule",
        severity: "Sévérité de l’alerte",
        message: "Message d’alerte",
        observed: "Valeur observée",
        position: "Position du véhicule",
        sentAt: "Date et heure du test",
        newsletterSubject: "Objet de la campagne",
        newsletterContent: "Contenu de la campagne",
      },
      newsletters: {
        new: "Nouvelle campagne",
        empty: "Aucune campagne.",
        loadFailed: "Impossible de charger les campagnes.",
        draftHint: "Brouillon — rien n’est envoyé avant votre validation.",
        campaignName: "Nom de la campagne",
        namePlaceholder: "Actualité clients d’octobre",
        nameHint: "Ce nom reste interne ; les destinataires voient l’objet.",
        design: "Modèle",
        designHint: "Choisissez un visuel, puis rédigez le contenu.",
        primaryLanguage: "Langue principale",
        optional: "Facultatif",
        addLanguage: "Ajouter {{language}}",
        switchPrimary: "Rédiger en {{language}} à la place",
        fallbackHint: "Si vous laissez cette langue vide, ses destinataires reçoivent la version {{language}}.",
        subject: "Objet",
        subjectPlaceholder: "De quoi parle ce message",
        content: "Contenu",
        button: "Bouton",
        buttonHint: "Facultatif. Un seul bouton sous le contenu.",
        buttonLabel: "Texte du bouton",
        buttonUrl: "Adresse du bouton",
        preheader: "Texte d’aperçu",
        preheaderHint: "La ligne affichée après l’objet dans la plupart des boîtes de réception.",
        nameRequired: "Donnez un nom à la campagne.",
        subjectRequired: "Saisissez un objet dans la langue de la campagne.",
        contentRequired: "Ajoutez du contenu dans la langue de la campagne.",
        ctaUrlRequired: "Le bouton a besoin d’une adresse commençant par http ou https.",
        previewEmpty: "L’aperçu apparaît dès qu’il y a un objet et du contenu.",
        sendNow: "Envoyer maintenant",
        sendNowConfirm: "Envoyer cette campagne à environ {{count}} destinataire(s) maintenant ?",
        sendingCount: "Envoi en cours vers {{count}} destinataire(s).",
        scheduleAt: "Date et heure d’envoi",
        everyone: "Tous les destinataires éligibles",
        chosenCustomers: "Uniquement certains clients",
        refine: "Affiner les sources et les langues",
        languagesHint: "Les destinataires des langues décochées sont entièrement ignorés.",
        tabs: {
          campaigns: "Campagnes",
          contacts: "Contacts",
        },
        stats: {
          subscribed: "Inscrits",
          unsubscribed: "Désinscrits",
          suppressed: "Bloqués",
          knownContacts: "Contacts connus",
        },
        columns: {
          campaign: "Campagne",
          design: "Modèle",
          target: "Cible",
          status: "Statut",
          delivery: "Envoyés",
          when: "Date",
        },
        edit: "Modifier",
        view: "Ouvrir",
        delete: "Supprimer le brouillon",
        deleted: "Brouillon supprimé.",
        deleteConfirm: "Supprimer ce brouillon ?",
        cancelConfirm: "Arrêter cette campagne ? Les destinataires non encore joints sont annulés.",
        deliveryLog: "Journal d’envoi",
        noRecipients: "Aucun destinataire enregistré.",
        rowCount: "{{count}} entrée(s)",
        failedCount: "{{count}} en échec",
        retryFailed: "Réessayer les adresses en échec",
        retried: "Adresses en échec remises en file.",
        searchContacts: "Rechercher une adresse, un nom ou une société",
        consent: "Abonnements",
        consentStatus: {
          SUBSCRIBED: "Inscrit",
          UNSUBSCRIBED: "Désinscrit",
        },
        consentUpdated: "Abonnement mis à jour.",
        unsubscribeAction: "Désinscrire",
        resubscribeAction: "Réinscrire",
        noSubscriptions: "Aucun abonnement enregistré.",
        approvals: "Approbation des contacts",
        approvalsHint: "Les contacts clients et personnel ne reçoivent les campagnes qu’après approbation.",
        approved: "Approuvé",
        notApproved: "Non approuvé",
        approve: "Approuver",
        revoke: "Retirer",
        approvalUpdated: "Approbation mise à jour.",
        noContacts: "Aucun contact trouvé.",
        contactType: {
          CUSTOMER: "Client",
          STAFF: "Personnel",
        },
        suppressions: "Adresses bloquées",
        suppressionsHint: "Adresses en rejet définitif ou bloquées ; elles ne sont jamais contactées.",
        suppressionRemoved: "Adresse retirée de la liste de blocage.",
        noSuppressions: "Aucune adresse bloquée.",
        contactsLoadFailed: "Impossible de charger les contacts.",
        variables: {
          recipientName: "Nom du destinataire",
          appName: "Nom de l’application",
          unsubscribeUrl: "Lien de désinscription",
        },
        audience: "Audience",
        approvedHint: "Les adresses supprimées ou désinscrites sont exclues automatiquement.",
        sources: "Sources des destinataires",
        source: {
          PORTAL_USERS: "Utilisateurs actifs du portail",
          CUSTOMER_CONTACTS: "Contacts clients",
          STAFF_CONTACTS: "Contacts du personnel actif",
        },
        approvedOnly: "Seuls les contacts explicitement approuvés sont éligibles.",
        languages: "Langues des destinataires",
        selectedCustomers: "{{count}} client(s) sélectionné(s).",
        estimated: "{{count}} éligible(s) · EN {{en}} · FR {{fr}}",
        estimating: "Estimation des destinataires éligibles…",
        saveDraft: "Enregistrer le brouillon",
        saved: "Campagne enregistrée.",
        saveFailed: "Impossible d’enregistrer la campagne.",
        discardConfirm: "Abandonner les modifications non enregistrées ?",
        preview: "Aperçu",
        preferencesLink: "Gérer les préférences e-mail",
        clone: "Dupliquer",
        cloned: "Campagne dupliquée dans un nouveau brouillon.",
        archive: "Archiver",
        archived: "Campagne archivée.",
        test: "Test d’envoi",
        send: "Envoyer le test",
        testHint: "Le test enregistre d’abord le brouillon, pour correspondre exactement à ce que recevront les destinataires.",
        testSent: "Test de newsletter envoyé.",
        testFailed: "Impossible d’envoyer le test.",
        previewFailed: "Impossible de générer l’aperçu.",
        schedule: "Planifier",
        scheduleAction: "Planifier",
        invalidSchedule: "Choisissez une date et une heure valides.",
        scheduledCount: "Campagne planifiée pour {{count}} destinataire(s).",
        emptyAudience: "Aucun destinataire éligible ne correspond à cette audience.",
        cancelAction: "Annuler la campagne",
        cancelled: "Campagne annulée.",
        reportFailed: "Impossible de charger le journal d’envoi.",
        actionFailed: "Impossible d’effectuer cette action sur la campagne.",
        status: {
          DRAFT: "Brouillon",
          SCHEDULED: "Planifiée",
          SENDING: "En cours d’envoi",
          SENT: "Envoyée",
          CANCELLED: "Annulée",
          ARCHIVED: "Archivée",
        },
      },
      recovery: {
        backToLogin: "Retour à la connexion",
        forgotTitle: "Réinitialiser votre mot de passe",
        forgotDescription: "Saisissez l’e-mail ou le nom d’utilisateur de votre compte.",
        emailOrUsername: "E-mail ou nom d’utilisateur",
        sendLink: "Envoyer le lien",
        checkInbox: "Consultez votre boîte de réception",
        genericForgot: "Si un compte actif correspond à ces informations, un lien de réinitialisation a été envoyé.",
        requestFailed: "Impossible d’effectuer la demande. Réessayez.",
        resetTitle: "Choisissez un nouveau mot de passe",
        resetDescription: "Utilisez un mot de passe fort et unique pour votre compte Fleet.",
        newPassword: "Nouveau mot de passe",
        confirmPassword: "Confirmer le mot de passe",
        passwordInvalid: "Le mot de passe ne respecte pas toutes les exigences.",
        invalidResetLink: "Ce lien est invalide, expiré ou déjà utilisé.",
        resetFailed: "Impossible de réinitialiser le mot de passe.",
        resetAction: "Réinitialiser le mot de passe",
        resetDone: "Mot de passe réinitialisé",
        resetDoneHint: "Les anciennes sessions ont été invalidées. Vous pouvez vous connecter.",
        signIn: "Se connecter",
        policy: {
          lengthMin: "Au moins 12 caractères",
          lengthMax: "Au plus 128 caractères",
          lowercase: "Une lettre minuscule",
          uppercase: "Une lettre majuscule",
          number: "Un chiffre",
          symbol: "Un symbole",
          match: "Mots de passe identiques",
        },
      },
      verification: {
        loadingTitle: "Vérification de votre e-mail",
        loadingDescription: "Veuillez patienter pendant la vérification du lien sécurisé.",
        doneTitle: "E-mail vérifié",
        doneDescription: "Votre adresse e-mail a été confirmée.",
        errorTitle: "Lien de vérification indisponible",
        errorDescription: "Ce lien est invalide, expiré ou déjà utilisé.",
        profileTitle: "Vérification de l’e-mail",
        profileUnknown: "Demandez un lien pour vérifier l’adresse du compte ou confirmer son état actuel.",
        profileSent: "Un lien de vérification a été envoyé à votre adresse.",
        profileVerified: "Votre adresse e-mail est vérifiée.",
        pendingEmail: "Vérification en attente : {{email}}",
        currentPassword: "Mot de passe actuel",
        passwordRequired: "Saisissez votre mot de passe actuel pour confirmer ce changement d’adresse.",
        send: "Envoyer le lien de vérification",
        resend: "Renvoyer le lien",
        sent: "E-mail de vérification envoyé.",
        alreadyVerified: "Votre adresse e-mail est déjà vérifiée.",
        sendFailed: "Impossible d’envoyer l’e-mail de vérification.",
      },
      preferences: {
        title: "Préférences de newsletter",
        description: "Utilisez le lien signé ci-dessous pour ne plus recevoir les newsletters de la plateforme.",
        unsubscribe: "Se désinscrire des newsletters",
        doneTitle: "Désinscription enregistrée",
        doneDescription: "Cette adresse ne recevra plus les newsletters de la plateforme.",
        invalidTitle: "Lien de préférences indisponible",
        invalidDescription: "Ce lien signé est invalide ou expiré.",
      },
    },
    access: {
      customerUsers: "Utilisateurs clients",
      fleetTeam: "Équipe Fleet",
      customerAccount: "Compte client",
      fleetAccount: "Compte équipe Fleet",
      platformAdmin: "Administrateur de plateforme",
      globalScope: "Périmètre global",
      selectedScope: "Clients sélectionnés",
      allScopes: "Tous les périmètres",
      locked: "Verrouillé",
      roleTemplate: "Modèle de rôle",
      multiWorkspace: "{{count}} espaces",
      users: {
        portalOnlyHint: "Comptes d’accès au portail uniquement. Le personnel opérationnel reste séparé dans Gestion du personnel.",
        revokeConfirm: "Révoquer l’accès de {{username}} ?",
        revoked: "Accès utilisateur révoqué."
      },
      invitations: {
        title: "Invitations",
        resend: "Renvoyer l’invitation",
        revoke: "Révoquer l’invitation",
        revokeConfirm: "Révoquer l’invitation en attente de {{username}} ?",
        revoked: "Invitation révoquée."
      },
      roles: {
        title: "Rôles et capacités",
        platformAdminHint: "Définissez les modèles protégés et personnalisés pour les comptes clients et l’équipe Fleet.",
        tenantAdminHint: "Consultez les rôles clients approuvés. Seuls les administrateurs de plateforme peuvent définir les modèles.",
        create: "Créer un rôle",
        edit: "Modifier le rôle",
        clone: "Cloner le rôle",
        archive: "Archiver le rôle",
        system: "Protégé",
        custom: "Personnalisé",
        archivedLabel: "Archivé",
        assignments: "{{count}} affectations",
        noDescription: "Aucune description.",
        none: "Aucun rôle dans cette famille.",
        select: "Sélectionnez un rôle pour prévisualiser ses accès effectifs.",
        protectedHint: "Ce rôle système est protégé. Son identité ne peut pas être renommée, archivée ou supprimée.",
        dangerousWarning: "Cet accès comprend des capacités d’administration sensibles. Vérifiez-le attentivement avant affectation.",
        effectivePreview: "Aperçu des accès effectifs",
        noCapabilities: "Ce rôle n’accorde aucune capacité.",
        editorHint: "Les capacités sélectionnées deviennent les accès effectifs du modèle.",
        internalName: "Nom interne",
        displayName: "Nom affiché",
        family: "Famille de compte",
        copySuffix: "copie",
        required: "Les noms interne et affiché sont requis.",
        saved: "Rôle enregistré.",
        archived: "Rôle archivé.",
        deleted: "Rôle supprimé.",
        loadFailed: "Impossible de charger les rôles.",
        saveFailed: "Impossible d’enregistrer le rôle.",
        archiveConfirm: "Archiver {{name}} ? Les affectations existantes seront conservées.",
        deleteConfirm: "Supprimer définitivement {{name}} ?"
      },
      wizard: {
        type: "Type d’utilisateur",
        identity: "Identité",
        scope: "Périmètre des données",
        role: "Modèles de rôle",
        platforms: "Accès aux plateformes",
        overrides: "Exceptions avancées",
        review: "Vérification",
        step: "Étape {{current}} sur {{total}}",
        customerTypeHint: "Un compte client avec une ou plusieurs adhésions à des espaces.",
        fleetTypeHint: "Un compte interne Fleet avec un périmètre global ou limité à certains clients.",
        platformAdminCurrent: "Ce compte existant est un superutilisateur sans restriction, distinct des modèles de rôle.",
        platformAdminUnsupported: "La promotion en superutilisateur n’est pas disponible ici, car l’API actuelle n’expose pas cette opération.",
        platformAdminRoleHint: "Les administrateurs de plateforme disposent d’un accès sans restriction. Aucun modèle de rôle ni exception de capacité ne s’applique.",
        tenantIdentityLocked: "Les administrateurs client ne peuvent pas modifier les champs d’identité globaux.",
        globalHint: "Accès à tous les clients actuels et futurs sans adhésion individuelle.",
        selectedHint: "Limiter l’accès à une liste explicite de clients.",
        chooseRole: "Choisir un rôle approuvé",
        roleRequired: "Choisissez un modèle de rôle valide pour chaque périmètre requis.",
        otherPlatformsAdminOnly: "Seuls les administrateurs de plateforme peuvent accorder l’accès aux autres plateformes.",
        enableOverrides: "Personnaliser les capacités",
        overrideHint: "Facultatif : ajoutez ou retirez des capacités du rôle sélectionné. Les différences sont signalées.",
        added: "Ajoutée",
        removed: "Retirée"
      }
    },
  }
}

export default fr
